import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Http } from "@angular/http";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import config from "../../config/config";

import { HomePage } from "../home/home";

/**
 * Generated class for the CadastroPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-cadastro",
  templateUrl: "cadastro.html"
})
export class CadastroPage {
  form: any = {};
  dados: any = {};
  banco: any = {};
  bancos: any = [];

  cpfValido: boolean;
  usuario: any;
  bemVindo: any;
  pode: boolean;
  pensionista: boolean;
  validar: boolean;
  file: any;
  foto = "public/perfildefault.jpg";
  dependentes: any = [];
  jornal = true;
  mochUp = null;

  interesse = [
    { val: "Educação", isChecked: false },
    { val: "Cultura", isChecked: false },
    { val: "Lazer", isChecked: false },
    { val: "Violência contra mulher", isChecked: false },
    { val: "Combate ao racismo", isChecked: false },
    { val: "Política", isChecked: false },
    { val: "Ciencia e tecnologia", isChecked: false },
    { val: "Economia", isChecked: false },
    { val: "Esporte", isChecked: false },
    { val: "Saúde", isChecked: false },
    { val: "Segurança pública", isChecked: false },
    { val: "Direitos humanos", isChecked: false }
  ];
  usuarioIdAuditoria: any;
  eFuncionario = false;
  Localizacao: any;
  dependente: { env: string; };
  orgaoList: { codigo: number; label: string; }[];
  validando: FormGroup
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public FormBuilder: FormBuilder
  ) {
    this.validando = this.FormBuilder.group({
      nome: ['', Validators.required],

    });
  }
  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.bemVindo = this.navParams.get("bemvindo");
    this.usuarioIdAuditoria = this.navParams.get("usuarioIdAuditoria");

    if (this.usuario.grupold == 2) {
      this.pode = true;
    }
    this.buscarBancos()
    // this.getCodigos()
  }

  voltarLogin() {
    this.navCtrl.setRoot(HomePage);
  }
  cadastrar(form, dados, banco) {



    if ((form.cpf && form.password && form.registro && form.nome && form.email && dados.siape && dados.sisapnet && dados.LocalizacaoUfrj && dados.sexo && dados.nascimento != undefined)||(form.cpf && form.password  && form.nome && form.email && dados.siape  && (form.grupold == 3||form.grupold == 5))) {
      this.dependadio();
      let loading = this.loadingCtrl.create({
        content: "Criando usuário aguarde um instante."
      });
      loading.present();
      if (banco.conta) {
        if (banco.conta.length < 10) {
          let tam = 10 - banco.conta.length;
          let conta = "";
          for (let g = 0; g < tam; g++) {
            conta += "0";
          }
          banco.conta = conta + banco.conta;
        }
      }
      form.banco = banco.banco;
      form.siape = dados.siape;

      form.agencia = banco.agencia;
      form.conta = banco.conta;
      form.usuarioIdAuditoria = this.usuarioIdAuditoria;

      dados.foto = this.foto;
      dados.interesse = JSON.stringify(this.interesse);

      this._http
        .post(config.urlAPI + "usuario/novo", form, {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          dados.usuariold = res.id;
          loading.dismiss();
          this._http
            .post(config.urlAPI + "usuario/dados", dados, {})
            .map(res => res.json())
            .toPromise()
            .then(res => {
              // this.subirImage();
              this.novoDepen(this.dependente);

              loading.dismiss();
              let alert = this.alertCtrl.create({
                title: "Cadastro",
                subTitle: "realizado com sucesso",
                buttons: [
                  {
                    text: "Voltar para Home",
                    handler: data => {
                      this.navCtrl.setRoot(HomePage);
                    }
                  }
                ]
              });
              alert.present();
            })
            .catch(error => {
              console.log(error);

              loading.dismiss();
            });
        })
        .catch(error => {
          loading.dismiss();
          console.log(error);
        });
    }else {
      let alert = this.alertCtrl.create({
        title: "Erro",
        subTitle: "É necessário preencher todos os campos obrigatórios",
        buttons: [
          {
            text: "OK",
            handler: data => {
              return true
            }
          }
        ]
      });
      alert.present();
    }
  }
  resultadoCPF(cpf, name) {
    if (cpf.length == 11) {
      let valido = this.TestaCPF(cpf);
      if (valido) {
        this.validar = true;
      } else {
        if (name == 1) {
          this.form.cpf = "";
        }
        if (name == 2) {
          this.dados.inscpf = "";
        }
        let alert = this.alertCtrl.create({
          title: "CPF",
          subTitle: "CPF invalido",
          buttons: [
            {
              text: "colocar outro",
              handler: data => { }
            }
          ]
        });
        alert.present();
      }
    } else {
      this.validar = false;
    }
  }
  TestaCPF(cpf) {
    cpf = cpf.replace(/\D/g, "");
    if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var result = true;
    [9, 10].forEach(function (j) {
      var soma = 0,
        r;
      cpf
        .split(/(?=)/)
        .splice(0, j)
        .forEach(function (e, i) {
          soma += parseInt(e) * (j + 2 - (i + 1));
        });
      r = soma % 11;
      r = r < 2 ? 0 : 11 - r;
      if (r != cpf.substring(j, j + 1)) result = false;
    });
    return result;
  }
  resultadoSiape(siape) {
    if (siape.length == 7) {
      this.dados.dvs = this.gerarSiapeDvs(siape);

      this.validar = true;

    } else {
      this.validar = false;
    }
  }
  gerarSiapeDvs(siape) {
    let valorA: any;
    let valorB: any;
    let valorD: any;
    let dv: any;

    valorA = 0;

    for (let i = 0; i < 7; i++) {
      valorA = valorA + parseInt(siape.substring(i, i + 1)) * (8 - i);
    }
    valorB = Math.trunc((valorA + 93) / 11);

    valorD = valorA + 93 - valorB * 11;

    dv = 11 - valorD;
    if (dv == 10) {
      dv = 0;
    }
    return dv;
  }
  buscaPorCep(env) {
    let cep = env;
    cep = cep.replace(/-/g, "");
    if (cep.length == 8) {
      this._http
        .get("https://viacep.com.br/ws/" + cep + "/json/", {})
        .map(res => res.json())
        .toPromise()
        .then(res => {
          let logradouro = res.logradouro.split(" ");
          let tipo = logradouro[0];
          let rua = "";
          for (let f = 1; f < logradouro.length; f++) {
            rua += logradouro[f] + " ";
          }

          this.dados.estado = res.uf;
          this.dados.cidade = res.localidade;
          this.dados.bairro = res.bairro;
          this.dados.rua = rua;
          this.dados.tipodeEndereco = tipo;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
  checkTelefone1(data) {
    let numero = null;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.dados.telefonePessoal = numero;
    }
  }
  checkTelefone2(data) {
    let numero = null;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.dados.telefoneResidencia = numero;
    }
  }
  checkTelefone3(data) {
    let numero = null;
    if (data.length == 1) {
      numero = "(" + data;
    } else if (data.length == 2) {
      numero = data;
    } else if (data.length == 3) {
      numero = data + ") ";
    } else if (data.length > 14) {
      numero = data.slice(0, 14);
    }

    if (numero) {
      this.dados.telefoneTrabalho = numero;
    }
  }
  checarPensionista(localizacaoUfrj) {
    if (localizacaoUfrj.substring(0, 3) == "888") {
      this.pensionista = true;
    } else {
      this.pensionista = true;
    }

    if (localizacaoUfrj.substring(0, 3) == "999") {
      this.jornal = true;
    } else {
      this.jornal = true;
    }
    console.log(this.pensionista);
  }
  arquivo(event) {
    this.file = <File>event.target.files[0];
    this.subirImage();
  }
  //colocar pra subir apenas depois de salvar tudo
  subirImage() {
    let imagem = this.file;
    const fd = new FormData();
    fd.append("image", imagem, imagem.name);
    this._http
      .post(config.urlAPI + "perfil/foto", fd, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.foto = res;
      })
      .catch(error => {
        console.log(error);
      });
  }
  adidep() {
    console.log(this.dependentes);

    let dependente = {
      id: Math.random() * 1000,
      nome: "",
      registro: this.form.registro,
      parentesco: ""
    };
    this.dependentes.push(dependente);
    console.log(this.dependentes);

  }
  // checar se essa função realmente faz sentido ficar aqui, parece ter sido copiada diretamente do cadastro 

  removeDep(element) {
    if (element.id != 0) {
      let alert = this.alertCtrl.create({
        title: "Excluir",
        subTitle: "Deseja realmente excluir o dependente",
        buttons: [
          {
            text: "Sim",
            handler: data => {
              const index = this.dependentes.indexOf(element);
              this.dependentes.splice(index, 1);
              this._http
                .get(config.urlAPI + "delete/dependente/" + element.id, {})
                .map(res => res.json())
                .toPromise()
                .then(res => { })
                .catch(error => {
                  console.log(error);
                });
            }
          },
          {
            text: "Não",
            handler: data => { }
          }
        ]
      });
      alert.present();
    } else {
      const index = this.dependentes.indexOf(element);
      this.dependentes.splice(index, 1);
    }
  }

  // checar se essa função realmente faz sentido ficar aqui, parece ter sido copiada diretamente do cadastro 
  dependadio() {
    let alterar = [];
    let salvar = [];
    for (let r = 0; r < this.dependentes.length; r++) {
      this.dependentes[r];
      if (this.dependentes[r].id != 0) {
        alterar.push(this.dependentes[r]);
      } else {
        if (
          this.dependentes[r].nome == "" ||
          this.dependentes[r].parentesco != "" ||
          this.dependentes[r].dataNascimento != ""
        ) {
          salvar.push(this.dependentes[r]);
        }
      }
    }
    if (salvar.length > 0) {
      let salvarenv = JSON.stringify(salvar);
      this.dependente = { env: salvarenv };
      // this.novoDepen(env);
    }
    if (alterar.length > 0) {
      let alterarenv = JSON.stringify(alterar);
      this.dependente = { env: alterarenv };

      // this.alterarDen(env);
    }
  }
  alterarDen(env) {
    this._http
      .post(config.urlAPI + "alterar/dependente", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => { })
      .catch(error => {
        console.log(error);
      });
  }

  novoDepen(env) {
    console.log(env);
    this._http
      .post(config.urlAPI + "novo/dependente", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => { })
      .catch(error => {
        console.log(error);
      });
  }
  diminuirFuncionario(env) {
    if (env == 2 || env == 1) {
      this.eFuncionario = false;
      this.validar = false;
    } else {
      this.eFuncionario = true;
      this.validar = true;
    }
  }


  getItems(ev) {
    this.getCodigos();
    const val = ev;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.Localizacao = this.Localizacao.filter((item) => {
        return (item.label.toString().toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    } else {
      this.getCodigos();
    }
    // console.log(this.items);
  }

  add(item) {
    this.dados.LocalizacaoUfrj = item.codigo;
    this.dados.unidade = item.label;
    // item.codigo = toString(item.codigo);
    console.log(this.dados.LocalizacaoUfrj);
    if (item.codigo == "99999999") {
      this.jornal = true;
    } else {
      this.jornal = false;
    }

    if (item.codigo.toString().substring(0, 3) == "888") {
      this.pensionista = true;
    } else {
      this.pensionista = false;
    }
    // if (item.codigo. == "88888888") {
    //   this.pensionista = true;
    // } else {
    //   this.pensionista = false;
    // }
    this.checarPensionista(item.codigo.toString());

  }


  getItems2(ev) {
    this.getOrgao();
    const val = ev;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.orgaoList = this.orgaoList.filter((item) => {
        return (item.label.toString().toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    } else {
      this.getOrgao();
    }
    // console.log(this.items);
  }

  add2(item) {
    this.dados.sisapnet = item.codigo;
    // this.dados.unidade=item.label;
    // console.log(this.dados.LocalizacaoUfrj);
    if (item == "99999999") {
      this.jornal = true;
    } else {
      this.jornal = true;
    }

    if (item.substring(0, 3) == "888") {
      this.pensionista = true;
    } else {
      this.pensionista = true;
    }


  }
  getCodigos() {
    this.Localizacao =
      [
        { codigo: 11000100, label: "Reitoria" },
        { codigo: 11010100, label: "Gabinete do Reitor" },
        { codigo: 11010101, label: "Secretaria de Administrativa do Gabinete do Reitor" },
        { codigo: 11010103, label: "Secretaria de Reitor" },
        { codigo: 11010105, label: "Secretaria do Gabinete do Reitor" },
        { codigo: 11010106, label: "Secretaria do Chefe de Gabinete" },
        { codigo: 11010107, label: "Setor de Informática" },
        { codigo: 11010111, label: "Coordenadoria de Comunicação" },
        { codigo: 11010113, label: "CPD" },
        { codigo: 11010200, label: "Divisão Gráfica" },
        { codigo: 11010201, label: "Seção de Acabamento" },
        { codigo: 11010202, label: "Seção de Editoração" },
        { codigo: 11010204, label: "Seção de Off-Set" },
        { codigo: 11010206, label: "Seção de Produção" },
        { codigo: 11012000, label: "Setor de Protocolo do Gabinete do Reitor" },
        { codigo: 11013000, label: "Assessores Gabinete do Reitor" },
        { codigo: 11013500, label: "Divisão de Relações Institucionias" },
        { codigo: 11014000, label: "Coordenação Atendimento aos Ógãos de Controle" },
        { codigo: 11015000, label: "Diretoria de Relações Internacionais" },
        { codigo: 11018000, label: "Coordenação das Atividades do Edifício Sede da Reitoria" },
        { codigo: 11018900, label: "Coord. de Relações Institucionais e Relações com a Sociedade" },
        { codigo: 11019000, label: "Coordenação de Reconstrução do Museu Nacional" },
        { codigo: 11020300, label: "Gabinete do Pro-Reitor 3" },
        { codigo: 11020500, label: "Gabinete do Pro-Reitor 5" },
        { codigo: 11030100, label: "Secretaria dos Órgãos Colegiados" },
        { codigo: 11040100, label: "Procuradoria Geral" },
        { codigo: 11040401, label: "Setor de Tecnologia da Informação" },
        { codigo: 11040602, label: "Assistência Administrativa da Consultoria Jurídica" },
        { codigo: 11040701, label: "Setor de Contencioso" },
        { codigo: 11050100, label: "Comissão Permanente de Pessoal Docente CPPD" },
        { codigo: 11070100, label: "Assessoria" },
        { codigo: 11070200, label: "Secretaria" },
        { codigo: 11070401, label: "Seção de Projetos" },
        { codigo: 11070500, label: "Divisão de Gestão Documental e da Informação" },
        { codigo: 11070501, label: "Protocolo Central" },
        { codigo: 11070502, label: "Seção de Gestão de Publicações" },
        { codigo: 11070503, label: "Seção de Gestão de Arquivos Corrente / Intermediário" },
        { codigo: 11070700, label: "Divisão de Preservação Documental" },
        { codigo: 11070701, label: "Seção de Arquivo Permanente" },
        { codigo: 11070702, label: "Seção de Digitalização" },
        { codigo: 11070703, label: "Laboratório de Conservação e Pequenos Restauros" },
        { codigo: 11080001, label: "Divisão Gráfica" },
        { codigo: 11080100, label: "Seção de Off-Set" },
        { codigo: 11100001, label: "Auditoria Interna" },
        { codigo: 11110001, label: "Superintendência Geral de Administração e Finanças" },
        { codigo: 11110002, label: "Assessoria de Gabinete" },
        { codigo: 11110003, label: "Secretaria Administrativa" },
        { codigo: 11110301, label: "Seção de Fiscalização de Contratos" },
        { codigo: 11110400, label: "Divisão de Contabilidade SG-6" },
        { codigo: 11110401, label: "Seção de Tomada de Contas" },
        { codigo: 11110500, label: "Divisão de Gestão Financeira SG-6" },
        { codigo: 11110501, label: "Seção de Execução Financeira" },
        { codigo: 11110503, label: "Setor de Folha de Pagamento" },
        { codigo: 11110600, label: "Almoxarifado" },
        { codigo: 11110800, label: "Divisão de Transporte" },
        { codigo: 11110801, label: "Seção de Manutenção" },
        { codigo: 11110802, label: "Seção de Controle de Frota" },
        { codigo: 11110900, label: "Divisão Gráfica" },
        { codigo: 11111000, label: "Divisão de Serviços Gerais" },
        { codigo: 11111100, label: "Divisão de Gestão  Documental e da Informação" },
        { codigo: 11120001, label: "Ouvidoria da UFRJ" },
        { codigo: 11130100, label: "Parque Tecnológico do Rio - UFRJ" },
        { codigo: 11150200, label: "Coordenacção de Relações Externas - CAE" },
        { codigo: 11150301, label: "Divisão de Rel. com os Órgãos de Cont. e Representação - DRR" },
        { codigo: 11150302, label: "Divisão de Monitoramento das Recomendações da CGU" },
        { codigo: 11150400, label: "Coord de Relaç Institucionais e Articulações com a Sociedade" },
        { codigo: 21000100, label: "Gabinete do Superintendente Geral 1" },
        { codigo: 21000200, label: "Secretaria da SG-1" },
        { codigo: 21200100, label: "Divisão de Ensino/SG-1" },
        { codigo: 21201000, label: "Seção de Legislação de Ensino/SG-1" },
        { codigo: 21202000, label: "Seção de Cursos e Programas/SG-1" },
        { codigo: 21300100, label: "Divisão de Registro de Estudantes/SG-1" },
        { codigo: 21301000, label: "Seção de Matrículas/SG-1" },
        { codigo: 21302000, label: "Seção de Assentamentos/SG-1" },
        { codigo: 21400100, label: "Divisão de Diplomas/SG-1" },
        { codigo: 21401000, label: "Seção de Histórico Escolar/SG1" },
        { codigo: 21402000, label: "Seção de Expedição e Registro de Diplomas/SG-1" },
        { codigo: 21600100, label: "Divisão de Integração Acadêmica/SG1" },
        { codigo: 21600200, label: "Seção de  Convênios e Estágios" },
        { codigo: 21700200, label: "Câmara de Corpo Docente" },
        { codigo: 21900100, label: "Coordenação de Acesso aos Cursos de Graduação/ SG1" },
        { codigo: 22000100, label: "Gabinete do Superintendente Acadêmico de Pesquisa - PR2" },
        { codigo: 22000300, label: "Gabinete do Superintendente Acadêmico de Pos Graduação - PR2" },
        { codigo: 22000400, label: "Gabinete do Superintendente Administrativo - PR2" },
        { codigo: 22100100, label: "Divisão de Ensino da Pos-Graduação / SG-2" },
        { codigo: 22102000, label: "Seção de Programas e Cursos/SG-2" },
        { codigo: 22201000, label: "Seção de Fomento e Pesquisa - SG2" },
        { codigo: 22301000, label: "Seção de Divulgação/SG-2" },
        { codigo: 22302000, label: "Seção de Intercâmbio/SG-2" },
        { codigo: 22500100, label: "Divisão de Acompanhamento Financeiro/SG-2" },
        { codigo: 22600100, label: "Divisão de Coordenação Execução e Pesquisa Cep/SG2" },
        { codigo: 22900100, label: "Agência UFRJ de Inovação" },
        { codigo: 23000100, label: "Gabinete do Superintendente Geral 3" },
        { codigo: 23000200, label: "Secretaria - SG3" },
        { codigo: 23000201, label: "Protocolo - SG3" },
        { codigo: 23150100, label: "Divisão de Planejamento,Orçamento e Gestão - SG3" },
        { codigo: 23152000, label: "Setor de Controle Orçamentário - SG3" },
        { codigo: 23155000, label: "Seção de Planejamento Orçamentário - SG3" },
        { codigo: 23350100, label: "Divisão de Gestão Orçamentária - SG3" },
        { codigo: 23353000, label: "Seção de Execução Orçamentária - SG3" },
        { codigo: 23354000, label: "Seção de Liquidação de Despesas - SG3" },
        { codigo: 23403000, label: "Seção de Bens Imóveis- SG3" },
        { codigo: 23900100, label: "Divisão Gestão de Tecnologia de Informação - SG3" },
        { codigo: 23903500, label: "Seção de Sistemas de Gerenciamento - SG3" },
        { codigo: 25000100, label: "Superintendência Formação Acadêmica da Extensão" },
        { codigo: 25000103, label: "Coordenação de Formação Acadêmica" },
        { codigo: 25000104, label: "Gestão e Acompanhamento e Desenvolvimento da Extensão" },
        { codigo: 25000200, label: "Superintendência Administrativa de Extensão" },
        { codigo: 25000203, label: "Coordenação Administrativa" },
        { codigo: 25000204, label: "Central de Apoio a Eventos" },
        { codigo: 25000205, label: "Gestão de Material e Patrimônio" },
        { codigo: 25000206, label: "Gestão Financeira" },
        { codigo: 25000208, label: "Administração da Sede" },
        { codigo: 25000300, label: "Assessoria Especial" },
        { codigo: 25000400, label: "Gabinete da Pró-Reitoria de Extensão" },
        { codigo: 25000401, label: "Secretaria" },
        { codigo: 25000403, label: "Seção de Comunicação" },
        { codigo: 25000404, label: "Gabinete da Pró-Reitoria de Extensão" },
        { codigo: 25000503, label: "Divisão de Atividades Gerenciais" },
        { codigo: 25000602, label: "Divisão de Cultura e Divulgação Científica" },
        { codigo: 25000903, label: "Divisão de Integração Universidade Comunidade" },
        { codigo: 25001100, label: "Superintendência Integração e Articulação da Extensão" },
        { codigo: 25001101, label: "Superintendência Integração e Articulação da Extensão" },
        { codigo: 25001103, label: "Coordenação de Integração e Articulação" },
        { codigo: 25001104, label: "Gestão de Produção Cultural" },
        { codigo: 25001105, label: "Gestão de Integração Comunitária" },
        { codigo: 25201000, label: "Seção de Administração da DAG/Sg5" },
        { codigo: 25500001, label: "Divisão de Integração Universidade Comunidade DIUC/Sg5" },
        { codigo: 25500100, label: "Seção Administrativa da DIUC/Sg5" },
        { codigo: 26100100, label: "Gab. da Sup. da Tec. da Informação e Comunicação TIC/PR3" },
        { codigo: 27010100, label: "Direção" },
        { codigo: 27010300, label: "Gabinete da Direção" },
        { codigo: 27010400, label: "Assistente da Direção" },
        { codigo: 27010500, label: "E-Plans" },
        { codigo: 27010501, label: "E-Plan Praia Vermelha" },
        { codigo: 27010502, label: "E-Plan Prédio Jorge Machado Moreira" },
        { codigo: 27010503, label: "Coord Escritório de Planejamento e Manut Campus Caxias/ETU " },
        { codigo: 27010600, label: "Divisão de Gestão de Qualidade" },
        { codigo: 27020800, label: "Coordenação Técnica de Obras" },
        { codigo: 27024000, label: "Divisão de Fiscalização" },
        { codigo: 27024001, label: "Seção Técnica de Fiscalização" },
        { codigo: 27024002, label: "Seção Técnica de Levantamento e Vistorias" },
        { codigo: 27024003, label: "Seção Técnica de Fiscalização Elétrica" },
        { codigo: 27030100, label: "Coordenação de Planejamento e Controle" },
        { codigo: 27030200, label: "Divisão de Apropriação, Controle e Engenharia de Custos" },
        { codigo: 27030201, label: "Seção de Apropriação e Reajustamento" },
        { codigo: 27030300, label: "Divisão de Análise de Conformidade" },
        { codigo: 27030400, label: "Divisão de Tecnologia da Informação" },
        { codigo: 27030401, label: "Seção de Suporte de Tecnologia da Informação " },
        { codigo: 27030402, label: "Seção de Desenvolvimento de Tecnologia da Informação" },
        { codigo: 27040300, label: "Divisão de Atividades Gerenciais" },
        { codigo: 27040301, label: "Seção de Protocolo" },
        { codigo: 27040302, label: "Seção de Patrimônio (Material)" },
        { codigo: 27040303, label: "Seção de Arquivo" },
        { codigo: 27040400, label: "Divisão de Recursos Humanos" },
        { codigo: 27060200, label: "Divisão de Engenharia Eletromecânica" },
        { codigo: 27060201, label: "Seção de Elétrica" },
        { codigo: 27060202, label: "Seção de Mecânica" },
        { codigo: 27060700, label: "Divisão de Engenharia Civil" },
        { codigo: 27060701, label: "Seção de Hidrossanitária" },
        { codigo: 27060702, label: "Seção de Estrutura" },
        { codigo: 27060900, label: "Coordenação de Projetos" },
        { codigo: 27061000, label: "Divisão de Projetos de Arquitetura" },
        { codigo: 27061001, label: "Gerência de Arquitetura" },
        { codigo: 27061002, label: "Gerência de Projetos" },
        { codigo: 27090100, label: "Divisão de Projetos e Imóveis Tombados" },
        { codigo: 27090200, label: "Divisão de Obras e Conservação em Imóveis Tombados" },
        { codigo: 27090300, label: "Coordenação de Preservação de Imóveis Tombados" },
        { codigo: 27090400, label: "Divisão de Captação de Recursos" },
        { codigo: 27100003, label: "Seção de Pessoal/ETU" },
        { codigo: 28000100, label: "Gabinete da Prefeitura" },
        { codigo: 28000200, label: "Secretaria da Prefeitura" },
        { codigo: 28070500, label: "PU/SPCM/Coordenação do Campus de Macaé" },
        { codigo: 28080200, label: "PU/SPCE/Seção de Obras Civis" },
        { codigo: 28080300, label: "PU/SPCE/Seção de Operações" },
        { codigo: 28080400, label: "PU/SPCE/Seção de Paisagismo" },
        { codigo: 28080500, label: "PU/ Subprefeitura dos Campi Externos" },
        { codigo: 28080800, label: "PU/SPCE/Seção de Redes Elétricas" },
        { codigo: 28090100, label: "PU/Coordenação do Centro da Cidade" },
        { codigo: 28100100, label: "PU/Diad/Seção de Pessoal" },
        { codigo: 28100200, label: "PU/CPA/Seção Financeira" },
        { codigo: 28100300, label: "PU/CPA/Seção de Material" },
        { codigo: 28100600, label: "PU/CPA/Seção de Compras" },
        { codigo: 28100700, label: "PU/CPA/Seção de Normas e Legislação" },
        { codigo: 28100800, label: "Divisão de Planejamento e Finanças/PU" },
        { codigo: 28100900, label: "Divisão de Recursos Humanos/PU" },
        { codigo: 28200400, label: "PU/DTP/Seção de Controle de Tráfego" },
        { codigo: 28200700, label: "PU/DTP/Seção de Controle de Veículos" },
        { codigo: 28209000, label: "PU/Divisão de Tráfego Urbano - DTP" },
        { codigo: 28300100, label: "PU/CIEU/DIMA/Setor de Obras Civis" },
        { codigo: 28300200, label: "PU/CIEU/DIMA/Seção de Manutenção Civil Urbana" },
        { codigo: 28300400, label: "PU/CIEU/DIMA/Seção de Refrigeração" },
        { codigo: 28300500, label: "PU/CIEU/DIMA/Setor de Pintura e Marcenaria" },
        { codigo: 28309000, label: "PU/Divisão de Manutenção - DIMA" },
        { codigo: 28400100, label: "PU/ASRH/Seção de Pessoal" },
        { codigo: 28400200, label: "PU/ASRH/Seção de Protocolo" },
        { codigo: 28400300, label: "PU/ASRH/Seção de Administração da Sede" },
        { codigo: 28400500, label: "PU/ASRH/Seção de Informatica" },
        { codigo: 28400600, label: "PU/ASRH/Seção de Saúde do Trabalhador" },
        { codigo: 28400700, label: "PU/ASRH/Setor de Arquivo" },
        { codigo: 28400800, label: "PU/ASRH/Setor de Portaria" },
        { codigo: 28400900, label: "PU/ASRH/Assessoria de Recursos Humanos" },
        { codigo: 28409000, label: "PU/ASRH/Setor de Limpeza Interna" },
        { codigo: 28500100, label: "PU/Divisão de Produção" },
        { codigo: 28500200, label: "PU/COEE/Setor de Pintura" },
        { codigo: 28509000, label: "PU/COEE/Setor de Serralheria" },
        { codigo: 28600100, label: "PU/CIEU/Seção de Elétrica" },
        { codigo: 28600200, label: "PU/CIEU/Seção de Hidráulica e Esgoto" },
        { codigo: 28609000, label: "PU/Divisão de Redes Urbanas - CIEU" },
        { codigo: 28700100, label: "PU/CSEG/ Divisão de Segurança" },
        { codigo: 28700400, label: "PU/CSEG/ Núcleo Praia Vermelha" },
        { codigo: 28700500, label: "PU/CSEG/ Núcleo Cidade Universutária" },
        { codigo: 28800100, label: "PU/COUA/Divisão da Frota Oficial" },
        { codigo: 28800400, label: "PU/COUA/Seção Operacional" },
        { codigo: 28800500, label: "PU/Coordenação de Operações Urbanas e Ambiente" },
        { codigo: 28809000, label: "PU/COUA/Seção de Horto Universitario" },
        { codigo: 28850100, label: "PU/Divisão de Limpeza Urbana" },
        { codigo: 28850200, label: "PU/COUA/Seção de Execução de Paisagismo" },
        { codigo: 28900100, label: "PU/ASPJ/Seção de Projetos" },
        { codigo: 28900300, label: "PU/ASPJ/Seção de Programação Visual" },
        { codigo: 29010100, label: "Gvta" },
        { codigo: 31000100, label: "Gabinete da Decania/CCMN" },
        { codigo: 31000400, label: "Superintendência/CCMN" },
        { codigo: 31000404, label: "Seção de Patrimônio/CCMN" },
        { codigo: 31000405, label: "Seção de Audiovisual/CCMN" },
        { codigo: 31000406, label: "Secretaria do BCMT/CCMN" },
        { codigo: 31000407, label: "Diretoria de Plan. Tecnologia e Serv. Multimídia/CCMN" },
        { codigo: 31000408, label: "Seção de Arquivo/CCMN" },
        { codigo: 31000409, label: "Diretoria de Planejamento e Gestão/CCMN" },
        { codigo: 31000410, label: "Administração da Sede/CCMN" },
        { codigo: 31000413, label: "Seção de Manutenção/CCMN" },
        { codigo: 31000414, label: "Seção de Segurança Patrimonial/CCMN" },
        { codigo: 31000416, label: "Seção de Contabilidade e Finanças/CCMN" },
        { codigo: 31000417, label: "Seção de Compras/CCMN" },
        { codigo: 31000418, label: "Almoxarifado/CCMN" },
        { codigo: 31000419, label: "Seção de Pessoal/CCMN" },
        { codigo: 31000421, label: "Biblioteca Central/CCMN" },
        { codigo: 31000422, label: "Protocolo/CCMN" },
        { codigo: 31000500, label: "Secretaria da Decania/CCMN" },
        { codigo: 31000600, label: "Biblioteca do CCMN" },
        { codigo: 31001002, label: "Coordenação de Extensão" },
        { codigo: 31009000, label: "Seção de Pessoal/CCMN" },
        { codigo: 31009100, label: "Seção de Contabilidade e Finanças/CCMN" },
        { codigo: 31009200, label: "Seção de Ensino/CCMN" },
        { codigo: 31009300, label: "Administração da Sede/CCMN" },
        { codigo: 31009400, label: "Seção de Comunicação e Protocolo/CCMN" },
        { codigo: 31009600, label: "Seção de Manutenção Técnica/CCMN" },
        { codigo: 31009700, label: "Almoxarifado/CCMN" },
        { codigo: 31010100, label: "Departamento de Matemática Pura/I Mat" },
        { codigo: 31010200, label: "Departamento de Ciência da Computação/I Mat" },
        { codigo: 31010300, label: "Departamento de Matemática/ Mat" },
        { codigo: 31010400, label: "Departamento de Métodos Estatísticos/I Mat" },
        { codigo: 31010500, label: "Departamento de Matemática Aplicada/I Mat" },
        { codigo: 31010600, label: "Secretaria de Apoio Departamental" },
        { codigo: 31018900, label: "Gabinete do Diretor do Instituto de Matemática" },
        { codigo: 31019000, label: "Seção de Atividades Gerenciais MA/CCMN" },
        { codigo: 31019010, label: "Seção de Pessoal MA/CCMN" },
        { codigo: 31019020, label: "Seção Financeira MA/CCMN" },
        { codigo: 31019030, label: "Protocolo MA/CCMN" },
        { codigo: 31019050, label: "Almoxarifado MA/CCMN" },
        { codigo: 31019060, label: "Seção de Patrimônio IM/CCMN" },
        { codigo: 31019110, label: "Secretaria de Ensino de Graduação MA/CCMN" },
        { codigo: 31019120, label: "Secretaria de Ensino de Pós-Graduação MA/CCMN" },
        { codigo: 31019200, label: "Administração da Sede MA/CCMN" },
        { codigo: 31019300, label: "Biblioteca Setorial MA/CCMN" },
        { codigo: 31030100, label: "Departamento de Física Teórica/I Fis" },
        { codigo: 31030200, label: "Departamento de Física e Matemática/I Fis" },
        { codigo: 31030300, label: "Departamento de Física Nuclear/I Fis" },
        { codigo: 31030400, label: "Departamento de Física dos Sólidos/I Fis" },
        { codigo: 31038900, label: "Gabinete do Diretor do Instituto Física" },
        { codigo: 31039000, label: "Seção de Atividades Gerenciais IF/CCMN" },
        { codigo: 31039010, label: "Seção de Pessoal IF/CCMN" },
        { codigo: 31039020, label: "Seção Financeira IF/CCMN" },
        { codigo: 31039030, label: "Protocolo/IF" },
        { codigo: 31039100, label: "Secretaria Acadêmica IF/CCMN" },
        { codigo: 31039110, label: "Secretaria de Ensino de Graduação IF/CCMN" },
        { codigo: 31039120, label: "Secretaria de Ensino de Pós-Graduação IF/CCMN" },
        { codigo: 31039130, label: "Laboratório Didático do Instituto de Física - Ladif/IF" },
        { codigo: 31039140, label: "Licenciatura/IF" },
        { codigo: 31039200, label: "Administração da Sede IF/CCMN" },
        { codigo: 31039210, label: "Oficina Mecânica / IF" },
        { codigo: 31039220, label: "Oficina Eletrônica / IF" },
        { codigo: 31039300, label: "Biblioteca Setorial do Instituto de Física/IF" },
        { codigo: 31039400, label: "Setor de Apoio a Informática/IF" },
        { codigo: 31039500, label: "Setor de Criogenia/IF" },
        { codigo: 31040100, label: "Departamento de Química Analítica/IQ" },
        { codigo: 31040200, label: "Departamento de Bioquímica/IQ" },
        { codigo: 31040300, label: "Departamento de Físico-Química/IQ" },
        { codigo: 31040400, label: "Departamento de Química Inorgânica/IQ" },
        { codigo: 31040500, label: "Departamento de Química Orgânica/IQ" },
        { codigo: 31040510, label: "Pólo de Xistoquímica / IQ" },
        { codigo: 31048900, label: "Gabinete do Diretor do Instituto de Química" },
        { codigo: 31049000, label: "Seção de Atividades Gerenciais IQ/CCMN" },
        { codigo: 31049010, label: "Seção de Pessoal IQ/CCMN" },
        { codigo: 31049020, label: "Seção Financeira IQ/CCMN" },
        { codigo: 31049040, label: "Setor de Compras IQ/CCMN" },
        { codigo: 31049100, label: "Secretaria Acadêmica IQ/CCMN" },
        { codigo: 31049120, label: "Secretaria de Ensino de Pós-Graduação IQ/CCMN" },
        { codigo: 31049201, label: "Manutenção IQ/CCMN" },
        { codigo: 31049300, label: "Biblioteca Setorial do Instituto de Química/IQ" },
        { codigo: 31049400, label: "Setor de Hialotecnia / IQ" },
        { codigo: 31050200, label: "Departamento de Geologia/I Geoc" },
        { codigo: 31050500, label: "Departamento de Meteorologia/I Geoc" },
        { codigo: 31050501, label: "Seção de Coordenação de Graduação em Meteorologia" },
        { codigo: 31050600, label: "Departamento de Geografia/I Geoc" },
        { codigo: 31050601, label: "Laboratório de Geoprocessamento IG/CCMN" },
        { codigo: 31050603, label: "Laboratório de Física IG/CCMN" },
        { codigo: 31058900, label: "Gabinete do Diretor do Instituto de Geociências" },
        { codigo: 31059000, label: "Seção de Atividades Gerenciais IG/CCMN" },
        { codigo: 31059010, label: "Seção de Pessoal IG/CCMN" },
        { codigo: 31059020, label: "Seção Financeira IG/CCMN" },
        { codigo: 31059040, label: "Protocolo IG/CCMN" },
        { codigo: 31059050, label: "Manutenção IG/CCMN" },
        { codigo: 31059060, label: "Setor de Transportes IG/CCMN" },
        { codigo: 31059070, label: "Setor de Compras - IG/CCMN" },
        { codigo: 31059080, label: "Setor de Patrimônio IG/CCMN" },
        { codigo: 31059090, label: "Setor de Almoxarifado - IG/CCMN" },
        { codigo: 31059100, label: "Secretaria Acadêmica IG/CCMN" },
        { codigo: 31059110, label: "Secretaria de Ensino de Graduação IG/CCMN" },
        { codigo: 31059120, label: "Secretaria de Ensino de Pós-Graduação IG/CCMN" },
        { codigo: 31059200, label: "Administração da Sede IG/CCMN" },
        { codigo: 31059300, label: "Biblioteca Setorial da Pós-Graduação em Geografia IG/CCMN" },
        { codigo: 31059400, label: "Museu da Geodiversidade - IGEO" },
        { codigo: 31059500, label: "Centro de Estudo em Mudancas Ambientais - IGEO" },
        { codigo: 31070100, label: "Área de Apoio Acadêmico/NCE" },
        { codigo: 31070200, label: "Área de Desenvolvimento/NCE" },
        { codigo: 31070400, label: "Área de Sistemas de Informação/NCE" },
        { codigo: 31070500, label: "Área Administrativa/NCE" },
        { codigo: 31078900, label: "Coordenação Geral/NCE" },
        { codigo: 31081000, label: "Departamento de Astronomia/Valongo" },
        { codigo: 31088900, label: "Gabinete do Diretor do Observatório do Valongo" },
        { codigo: 31089100, label: "Administração da Sede do Observatório do Valongo" },
        { codigo: 31089200, label: "Seção de Atividades Gerenciais do Valongo" },
        { codigo: 31089300, label: "Biblioteca Setorial do Observatório do Valongo" },
        { codigo: 32000100, label: "Decania do C L A" },
        { codigo: 32000200, label: "Escritório de Planejamento/CLA" },
        { codigo: 32000400, label: "Gabinete do Superintendente CLA" },
        { codigo: 32000500, label: "Secretaria do CLA" },
        { codigo: 32009000, label: "Seção de Pessoal/CLA" },
        { codigo: 32009100, label: "Seção de Contabilidade e Finanças/CLA" },
        { codigo: 32009200, label: "Seção de Ensino/CLA" },
        { codigo: 32009300, label: "Administração da Sede/CLA" },
        { codigo: 32009400, label: "Seção de Comunicação e Protocolo/CLA" },
        { codigo: 32009500, label: "Seção de Material/CLA" },
        { codigo: 32009600, label: "Seção de Manutenção Técnica/CLA" },
        { codigo: 32009700, label: "Almoxarifado/CLA" },
        { codigo: 32010100, label: "Departamento de Análise e Representação da Forma/FAU" },
        { codigo: 32010200, label: "Departamento de Tecnologia da Construção/FAU" },
        { codigo: 32010300, label: "Departamento de Estruturas/FAU" },
        { codigo: 32010400, label: "Departamento de História e Teoria/FAU" },
        { codigo: 32010500, label: "Departamento de Projeto de Arquitetura/FAU" },
        { codigo: 32010600, label: "Departamento de Urbanismo e Meio Ambiente/FAU" },
        { codigo: 32018900, label: "Gabinete do Diretor/FAU" },
        { codigo: 32019000, label: "Seção de Atividades Gerenciais FAU/CLA" },
        { codigo: 32019010, label: "Seção de Pessoal FAU/CLA" },
        { codigo: 32019020, label: "Seção Financeira FAU/CLA" },
        { codigo: 32019100, label: "Coordenação Executiva da Graduação da FAU" },
        { codigo: 32019110, label: "Seção de Ensino" },
        { codigo: 32019200, label: "Administração da Sede FAU/CLA" },
        { codigo: 32019300, label: "Biblioteca Central do CLA" },
        { codigo: 32019400, label: "Programa de Pós-Graduação em Urbanismo FAU/CLA" },
        { codigo: 32019500, label: "Programa de Pos-Graduação em Arquitetura FAU/CLA" },
        { codigo: 32020100, label: "Coordenação de Pós-Graduação / EBA" },
        { codigo: 32020200, label: "Departamento de Técnicas de Representação BAR / EBA" },
        { codigo: 32020300, label: "Departamento de Representação da Forma BAF / EBA" },
        { codigo: 32020500, label: "Departamento de Artes Base BAB / EBA" },
        { codigo: 32020502, label: "Atelier Escultura Mpm/EBA" },
        { codigo: 32020504, label: "Atelier de Modelagem/EBA" },
        { codigo: 32020600, label: "Departamento de Artes Utilitárias BAU / EBA" },
        { codigo: 32020800, label: "Departamento de Desenho Industrial BAI / EBA" },
        { codigo: 32020801, label: "Oficinas de Madeira BAI / EBA" },
        { codigo: 32020802, label: "Oficinas de Metal BAI / EBA" },
        { codigo: 32020806, label: "Oficinas de Estamparia BAI / EBA" },
        { codigo: 32020807, label: "Oficinas de Plástico BAI / EBA" },
        { codigo: 32020900, label: "Departamento de Comunicação Visual BAV / EBA" },
        { codigo: 32020901, label: "Laboratório Fotográfico BAV / EBA" },
        { codigo: 32021001, label: "Coordenação de Graduação / EBA" },
        { codigo: 32021002, label: "Seção de Ensino / EBA" },
        { codigo: 32021100, label: "Departamento de História e Teoria da Arte BAH / EBA" },
        { codigo: 32021400, label: "Departamento de Artes Visuais-Escultura BAE / EBA" },
        { codigo: 32021500, label: "Departamento de Artes Teatrais BAT / EBA" },
        { codigo: 32021600, label: "Departamento de Arte e Preservação BAP / EBA" },
        { codigo: 32021800, label: "Coordenação Acadêmica de Memória e Patrimônio / EBA" },
        { codigo: 32028900, label: "Gabinete da Direção / EBA" },
        { codigo: 32028903, label: "Direitos Autorais / EBA" },
        { codigo: 32029000, label: "Seção de Atividades Gerenciais / EBA" },
        { codigo: 32029010, label: "Seção de Pessoal / EBA" },
        { codigo: 32029020, label: "Seção Financeira / EBA" },
        { codigo: 32029100, label: "Chefia de Departamento / EBA" },
        { codigo: 32029120, label: "Secretaria de Ensino de Pós-Graduação / EBA" },
        { codigo: 32029200, label: "Administração da Sede / EBA" },
        { codigo: 32029400, label: "Direção Adjunta de Cultura / EBA" },
        { codigo: 32030100, label: "Departamento de Teclado e Percussão/EM" },
        { codigo: 32030200, label: "Departamento de Composição/EM" },
        { codigo: 32030300, label: "Departamento de Arco e Cordas Dedilhadas/EM" },
        { codigo: 32030400, label: "Departamento de Musicologia e Educação Musical/EM" },
        { codigo: 32030500, label: "Departamento Vocal/EM" },
        { codigo: 32030600, label: "Departamento de Instrumento de Sopro/EM" },
        { codigo: 32030700, label: "Departamento de Música de Conjunto/EM" },
        { codigo: 32030801, label: "Seção de Comunicação/EM" },
        { codigo: 32030802, label: "Seção - Núcleo de Documentação Arquivística/EM" },
        { codigo: 32030803, label: "Seção de Informática/EM" },
        { codigo: 32030804, label: "Seção de Patrimônio/EM" },
        { codigo: 32030805, label: "Seção de Audiovisual/EM" },
        { codigo: 32030806, label: "Seção de Almoxarifado/EM" },
        { codigo: 32038900, label: "Gabinete do Diretor da Escola de Música" },
        { codigo: 32039000, label: "Seção de Atividades Gerenciais EM/CLA" },
        { codigo: 32039010, label: "Seção de Pessoal EM/CLA" },
        { codigo: 32039020, label: "Seção Financeira EM/CLA" },
        { codigo: 32039040, label: "Protocolo EM/CLA" },
        { codigo: 32039100, label: "Secretaria Acadêmica EM/CLA" },
        { codigo: 32039110, label: "Secretaria de Ensino de Graduação EM/CLA" },
        { codigo: 32039120, label: "Secretaria de Ensino de Pós-Graduação EM/CLA" },
        { codigo: 32039130, label: "Secretaria de Extensão EM/CLA" },
        { codigo: 32039200, label: "Administração da Sede EM/CLA" },
        { codigo: 32039300, label: "Seção de Organização e Divulgação Artística EM/CLA" },
        { codigo: 32039400, label: "Biblioteca Setorial Música/EM" },
        { codigo: 32039500, label: "Setor de Direitos Autorais EM/CLA" },
        { codigo: 32040100, label: "Departamento de Letras Clássicas/FL" },
        { codigo: 32040200, label: "Departamento de Letras Vernáculas/FL" },
        { codigo: 32040300, label: "Departamento de Letras Anglo-Germânicas/FL" },
        { codigo: 32040400, label: "Departamento de Letras Neo-Latinas/FL" },
        { codigo: 32040500, label: "Departamento de Letras Orientais e Eslavas/FL" },
        { codigo: 32040600, label: "Departamento de Linguística e Filologia/FL" },
        { codigo: 32040700, label: "Departamento de Ciências da Literatura/FL" },
        { codigo: 32040800, label: "Departamento de Letras - LIBRAS/FL" },
        { codigo: 32040900, label: "SCDP - Sistema de Concessão de Diárias e Passagens FL/CLA" },
        { codigo: 32041000, label: "Protocolo FL/CLA" },
        { codigo: 32041100, label: "CLAC - Cursos de Línguas Aberto à Comunidade FL/CLA" },
        { codigo: 32041200, label: "Setor de Arquivo FL/CLA" },
        { codigo: 32041400, label: "Laboratório de Informática FL/CLA" },
        { codigo: 32041500, label: "Setor de Diplomas FL/CLA" },
        { codigo: 32042600, label: "Coordenação de Relações Internacionais FL/CLA" },
        { codigo: 32042700, label: "Comissão de Acessibilidade FL/CLA" },
        { codigo: 32042900, label: "Seção de Audiovisual FL/CLA" },
        { codigo: 32043000, label: "CEAC - Centro de Estudos Afrânio Coutinho FL/CLA" },
        { codigo: 32043100, label: "PACC - Programa Avançado de Cultura Contemporânea FL/CLA" },
        { codigo: 32043200, label: "COAA - Comissão de Orientação e Apoio Acadêmico FL/CLA" },
        { codigo: 32043300, label: "Setor de Publicação FL/CLA" },
        { codigo: 32043400, label: "Setor de Extensão/Setor Cultural FL/CLA" },
        { codigo: 32048900, label: "Gabinete de Diretor da Faculdade de Letras" },
        { codigo: 32049000, label: "Seção de Atividades Gerenciais FL/CLA" },
        { codigo: 32049010, label: "Seção de Pessoal FL/CLA" },
        { codigo: 32049020, label: "Seção Financeira FL/CLA" },
        { codigo: 32049030, label: "Almoxarifado FL/CLA" },
        { codigo: 32049100, label: "Secretaria Acadêmica de Comunicação FL/CLA" },
        { codigo: 32049110, label: "Secretaria de Ensino de Graduação FL/CLA" },
        { codigo: 32049120, label: "Secretaria de Ensino de Pós-Graduação FL/CLA" },
        { codigo: 32049200, label: "Administração da Sede FL/CLA" },
        { codigo: 32049300, label: "Biblioteca Setorial da Letras/FL" },
        { codigo: 32049500, label: "Setor de Informática FL/CLA" },
        { codigo: 33000100, label: "Decania do CFCH" },
        { codigo: 33000400, label: "Gabinete de Superintendente do CFCH" },
        { codigo: 33000500, label: "Secretaria do CFCH" },
        { codigo: 33000600, label: "Biblioteca do CFCH" },
        { codigo: 33009000, label: "Seção de Pessoal/CFCH" },
        { codigo: 33009100, label: "Seção de Contabilidade e Finanças/CFCH" },
        { codigo: 33009200, label: "Seção de Ensino/CFCH" },
        { codigo: 33009300, label: "Administração da Sede/CFCH" },
        { codigo: 33009400, label: "Seção de Comunicação e Protocolo/CFCH" },
        { codigo: 33009500, label: "Seção de Material/CFCH" },
        { codigo: 33009700, label: "Almoxarifado/CFCH" },
        { codigo: 33010100, label: "Departamento de Filosofia/IFCS" },
        { codigo: 33010300, label: "Departamento de Ciências Sociais/IFCS" },
        { codigo: 33010500, label: "Departamento de Ciência Política/IFCS" },
        { codigo: 33011000, label: "Departamento de Sociologia/IFCS" },
        { codigo: 33011500, label: "Departamento de Antropologia Cultural" },
        { codigo: 33011700, label: "Setor de Patrimônio/IFCS" },
        { codigo: 33011800, label: "Setor de Compras/IFCS" },
        { codigo: 33018900, label: "Gabinete do Diretor/IFCS" },
        { codigo: 33019010, label: "Setor de Recursos Humanos/IFCS" },
        { codigo: 33019020, label: "Setor Financeiro/IFCS" },
        { codigo: 33019100, label: "Secretaria Acadêmica IFCS/CFCH" },
        { codigo: 33019120, label: "Secretaria de Ensino de Pós-Graduação IFCS/CFCH" },
        { codigo: 33019130, label: "Protocolo do IFCS/CFCH" },
        { codigo: 33019200, label: "Administração da Sede IFCS/CFCH" },
        { codigo: 33019300, label: "Biblioteca Setorial do IFCS/CFCH" },
        { codigo: 33020100, label: "Departamento de Psicologia Geral Experimental/IP" },
        { codigo: 33020500, label: "Departamento de Psicometria/IP" },
        { codigo: 33020600, label: "Departamento de Psicologia Social/IP" },
        { codigo: 33020700, label: "Departamento de Psicologia Clínica/IP" },
        { codigo: 33028900, label: "Gabinete do Diretor do Instituto de Psicologia" },
        { codigo: 33029000, label: "Seção de Atividades Gerenciais Psi/CFCH" },
        { codigo: 33029010, label: "Seção de Pessoal Psi/CFCH" },
        { codigo: 33029020, label: "Seção Financeira Psi/CFCH" },
        { codigo: 33029030, label: "Protocolo Psi/CFCH" },
        { codigo: 33029110, label: "Secretaria de Ensino de Graduação Psi/CFCH" },
        { codigo: 33029120, label: "Secretaria de Ensino de Pós-Graduação Psi/CFCH" },
        { codigo: 33029200, label: "Administração da Sede Psi/CFCH" },
        { codigo: 33029300, label: "Divisão de Psicologia Aplicada - IP " },
        { codigo: 33029400, label: "Coordenação de Ensino e Graduação - IP" },
        { codigo: 33031100, label: "Departamento de Fundamentos da Comunicação" },
        { codigo: 33031200, label: "Departamento de Expressão e Linguagens" },
        { codigo: 33031300, label: "Departamento de Métodos e Áreas Conexas" },
        { codigo: 33033500, label: "Laboratório de Fotografia" },
        { codigo: 33034500, label: "Centro de Tecnologia de Comunicação" },
        { codigo: 33038900, label: "Gabinete do Diretor da Escola de Comunicação" },
        { codigo: 33038901, label: "Setor de Extensão/ECO" },
        { codigo: 33039000, label: "Seção de Atividades Gerenciais ECO/CFCH" },
        { codigo: 33039010, label: "Protocolo/Arquivo ECO" },
        { codigo: 33039020, label: "Seção de Pessoal ECO/CFCH" },
        { codigo: 33039110, label: "Secretaria de Ensino de Graduação ECO/CFCH" },
        { codigo: 33039120, label: "Secretaria de Ensino de Pós-Graduação ECO/CFCH" },
        { codigo: 33039200, label: "Administração da Sede ECO/CFCH" },
        { codigo: 33039600, label: "Núcleo de Imprensa ECO" },
        { codigo: 33040400, label: "Seção de Cultura/FE" },
        { codigo: 33040600, label: "Departamento de Administração da Educação/FE" },
        { codigo: 33040700, label: "Departamento de Didatica/FE" },
        { codigo: 33040800, label: "Departamento de Fundamentos da Educação/FE" },
        { codigo: 33048900, label: "Gabinete da Direção/FE" },
        { codigo: 33049000, label: "Seção de Atividades Gerenciais FE/CFCH" },
        { codigo: 33049010, label: "Seção de Pessoal FE/CFCH" },
        { codigo: 33049020, label: "Seção Financeira FE/CFCH" },
        { codigo: 33049100, label: "Secretaria Acadêmica FE/CFCH" },
        { codigo: 33049110, label: "Secretaria Acadêmica de Graduação FE/CFCH" },
        { codigo: 33049120, label: "Secretaria Acadêmica de Pós-Graduação FE/CFCH" },
        { codigo: 33049200, label: "Administração da Sede FE/CFCH" },
        { codigo: 33050100, label: "Escola de Educação Infantil" },
        { codigo: 33060100, label: "Departamento de Fundamentos do Serviço Social/ESS" },
        { codigo: 33060200, label: "Departamento de Métodos e Técnicas do Serviço Social/ESS" },
        { codigo: 33060300, label: "Departamento de Política Social e Serviço Social/ESS" },
        { codigo: 33068820, label: "Centro de Memória, Documentação e Arquivo/ESS" },
        { codigo: 33068900, label: "Gabinete do Diretor da Escola de Serviço Social" },
        { codigo: 33068910, label: "Coordenação de Práticas de Ensino em Serviço Social/ESS" },
        { codigo: 33068920, label: "Laboratório de Informática/ESS" },
        { codigo: 33068950, label: "Coordenação de Curso de Extensão/ESS" },
        { codigo: 33069000, label: "Seção de Atividades Gerenciais/ESS" },
        { codigo: 33069010, label: "Seção de Pessoal/ESS" },
        { codigo: 33069020, label: "Setor Financeiro/ESS" },
        { codigo: 33069030, label: "Protocolo ESS/CFCH" },
        { codigo: 33069040, label: "Setor de Compras/ESS" },
        { codigo: 33069050, label: "Setor de Patrimônio/ESS" },
        { codigo: 33069060, label: "Administração Predial/ESS" },
        { codigo: 33069070, label: "Almoxarifado/ESS" },
        { codigo: 33069110, label: "Secretaria Acadêmica de Graduação/ESS" },
        { codigo: 33069120, label: "Secretaria Acadêmica de Pós-Graduação/ESS" },
        { codigo: 33069123, label: "Setor de Publicação e Coleta de Dados/ESS" },
        { codigo: 33069300, label: "Secretaria dos Departamentos/ESS" },
        { codigo: 33070100, label: "Departamento de 1oe 2o Graus do Colégio de Aplicação" },
        { codigo: 33078900, label: "Gabinete do Diretor do Colégio de Aplicação" },
        { codigo: 33079000, label: "Secretaria do CAP/CFCH" },
        { codigo: 33079100, label: "Serviço de Orientação Educacional CAP/CFCH" },
        { codigo: 33079200, label: "Administração da Sede CAP/CFCH" },
        { codigo: 33079300, label: "Seção de Atividades Gerenciais CAP/CFCH" },
        { codigo: 33079310, label: "Seção de Pessoal CAP/CFCH" },
        { codigo: 33079400, label: "Biblioteca Setorial do CAP/CFCH" },
        { codigo: 33080001, label: "Núcleo de Estudos de Políticas Públicas em Direitos Humanos" },
        { codigo: 33088900, label: "Direção NEPP-DH" },
        { codigo: 33089001, label: "Setor de Pessoal/NEPP" },
        { codigo: 33089100, label: "Secretaria do PPDH/NEPP" },
        { codigo: 33090100, label: "Diretoria Adjunta de Graduação e Extensão - IH " },
        { codigo: 33090110, label: "Secretaria de Graduação e Extensão - IH " },
        { codigo: 33090200, label: "Diretoria Adjunta de Administração - IH" },
        { codigo: 33090210, label: "Secretaria de Recursos Humanos - IH" },
        { codigo: 33090220, label: "Secretaria de Finanças - IH" },
        { codigo: 33090230, label: "Protocolo - IH" },
        { codigo: 33090240, label: "Arquivo - IH " },
        { codigo: 33090250, label: "Secretaria de Patrimônio - IH" },
        { codigo: 33090300, label: "Programa de Pós-Graduação em História Social - IH " },
        { codigo: 33090301, label: "Secretaria de Pós-Graduação em História Social - IH" },
        { codigo: 33090400, label: "Programa de Pós-Graduação em História Comparada - IH" },
        { codigo: 33090401, label: "Secretaria de Pós-Graduação em História Comparada - IH" },
        { codigo: 33090500, label: "Docentes - IH" },
        { codigo: 33090601, label: "Secretaria de Pós-Graduação em Ensino de História - IH" },
        { codigo: 33098900, label: "Gabinete do Diretor - IH" },
        { codigo: 34000100, label: "Gabinete do Decano / CCJE" },
        { codigo: 34000400, label: "Gabinete do Superintendente CCJE" },
        { codigo: 34000600, label: "Biblioteca do CCJE" },
        { codigo: 34001100, label: "Coordenação de Integração Acadêmica Ensino de Graduação/CCJE" },
        { codigo: 34009000, label: "Seção de Pessoal/CCJE" },
        { codigo: 34009100, label: "Seção de Contabilidade e Finanças/CCJE" },
        { codigo: 34009200, label: "Seção de Ensino/CCJE" },
        { codigo: 34009300, label: "Setor de Manutenção / CCJE " },
        { codigo: 34009400, label: "Seção de Protocolo e Documentos Digitais/CCJE" },
        { codigo: 34009500, label: "Seção de Material/CCJE" },
        { codigo: 34009700, label: "Seção de Almoxarifado / CCJE" },
        { codigo: 34011000, label: "Departamento de Teoria do Direito" },
        { codigo: 34011100, label: "Departamento do Direito Civil" },
        { codigo: 34011200, label: "Departamento de Direito Social e Econômico" },
        { codigo: 34011300, label: "Departamento de Direito do Estado" },
        { codigo: 34012500, label: "Coordenação do Estágio Forense" },
        { codigo: 34018900, label: "Gabinete do Diretor da Faculdade de Direito" },
        { codigo: 34019000, label: "Seção de Atividades Gerenciais FD/CCJE" },
        { codigo: 34019100, label: "Secretaria Acadêmica FD/CCJE" },
        { codigo: 34019110, label: "Secretaria de Ensino de Graduação FD/CCJE" },
        { codigo: 34019120, label: "Secretaria de Ensino de Pós-Graduação FD/CCJE" },
        { codigo: 34019200, label: "Administração da Sede FD/CCJE" },
        { codigo: 34019400, label: "Setor de Pessoal" },
        { codigo: 34019500, label: "Biblioteca Setorial de Direito/FD" },
        { codigo: 34030100, label: "Programa de Planejamento Urbano Regional/IPPUR" },
        { codigo: 34038900, label: "Gabinete do Diretor do IPPUR" },
        { codigo: 34039000, label: "Secretaria de Ensino da Pós Graduação do IPPUR/CCJE" },
        { codigo: 34039100, label: "Administração da Sede/IPPUR" },
        { codigo: 34039400, label: "Seção de Atividades Gerenciais IPPUR" },
        { codigo: 34039410, label: "Seção de Pessoal IPPUR" },
        { codigo: 34039420, label: "Seção Financeira IPPUR" },
        { codigo: 34039430, label: "Secretaria de Pesquisa, Divulgação e Extensão/IPPUR" },
        { codigo: 34050100, label: "Programa de Administração" },
        { codigo: 34058900, label: "Gabinete do Diretor COPPEAD" },
        { codigo: 34059000, label: "Seção de Atividades Gerenciais COPPEAD" },
        { codigo: 34059010, label: "Seção de Pessoal COPPEAD" },
        { codigo: 34059020, label: "Seção Financeira COPPEAD" },
        { codigo: 34059100, label: "Secretaria Acadêmica COPPEAD" },
        { codigo: 34059200, label: "Administração da Sede COPPEAD/CCJE" },
        { codigo: 34059300, label: "Biblioteca Setorial da COPPEAD" },
        { codigo: 34060100, label: "Gabinete do Diretor do Ie/CCJE" },
        { codigo: 34060110, label: "Secretaria da Diretoria Ie/CCJE" },
        { codigo: 34061000, label: "Diretoria de Graduação Ie/CCJE" },
        { codigo: 34061010, label: "Secretaria Acadêmica de Graduação Ie/CCJE" },
        { codigo: 34062000, label: "Diretoria de Pós-Graduação e Extensão Ie/CCJE" },
        { codigo: 34062010, label: "Secretaria Acadêmica de Pós-Graduação e Extensão Ie/CCJE" },
        { codigo: 34063010, label: "Secretaria de Pesquisa Ie/CCJE" },
        { codigo: 34063020, label: "Núcleo de Computação e Áudio Visual - Nuca Ie/CCJE" },
        { codigo: 34064010, label: "Seção de Orçamento e Finanças Ie/CCJE" },
        { codigo: 34064020, label: "Seção de Serviços Gerais Ie/CCJE" },
        { codigo: 34064040, label: "Seção de Pessoal Ie/CCJE" },
        { codigo: 34064050, label: "Seção de Patrimônio e Almoxarifado Ie/CCJE" },
        { codigo: 34070100, label: "Gabinete do Diretor da Facc/CCJE" },
        { codigo: 34070103, label: "Secretaria do Gabinete da Direção Facc/CCJE" },
        { codigo: 34070300, label: "Depto de Biblioteconomia e Gestão de Unidades/FACC" },
        { codigo: 34071000, label: "Departamento de Contabilidade da  Facc/CCJE" },
        { codigo: 34072000, label: "Departamento de Administração Facc/CCJE" },
        { codigo: 34073000, label: "Seção de Atividades Gerenciais Facc/CCJE" },
        { codigo: 34073010, label: "Seção de Pessoal Facc/CCJE" },
        { codigo: 34073020, label: "Seção Financeira Facc/CCJE" },
        { codigo: 34073040, label: "Seção de Patrimônio Facc/CCJE" },
        { codigo: 34073050, label: "Seção de Informática Facc/CCJE" },
        { codigo: 34073060, label: "Seção de Almoxarifado Facc/CCJE" },
        { codigo: 34073070, label: "Seção de Protocolo Facc/CCJE" },
        { codigo: 34074000, label: "Secretaria Acadêmica Facc/CCJE" },
        { codigo: 34075000, label: "Administração da Sede Facc/CCJE" },
        { codigo: 34076000, label: "Secretaria de Pós-Graduação e Projetos Especiais Facc/CCJE" },
        { codigo: 34080001, label: "Gabinete do Diretor do IRID/CCJE" },
        { codigo: 34081000, label: "Departamento de Economia Política Internacional - IRID/CCJE" },
        { codigo: 34082000, label: "Coordenação de Graduação do Curso de Relações Internacionais" },
        { codigo: 34089010, label: "Seção de Pessoal IRID/CCJE" },
        { codigo: 34089020, label: "Seção Financeira IRID/CCJE" },
        { codigo: 34089030, label: "Seção de Compras e Materiais IRID/CCJE" },
        { codigo: 34089040, label: "Almoxarifado IRID/CCJE" },
        { codigo: 34089100, label: "Secretaria Acadêmica IRID/CCJE" },
        { codigo: 34089110, label: "Secretaria Acadêmica de Graduação IRID/CCJE" },
        { codigo: 35000100, label: "Decania do CCS" },
        { codigo: 35000109, label: "Setor de Humanização e Acolhimento/CCS" },
        { codigo: 35000200, label: "Escritório de Planejamento/CCS" },
        { codigo: 35000400, label: "Superintendência Gerencial/CCS" },
        { codigo: 35000404, label: "Seção de Patrimônio/CCS" },
        { codigo: 35000500, label: "Secretaria Administrativa/CCS" },
        { codigo: 35000600, label: "Biblioteca do CCS" },
        { codigo: 35001000, label: "Coordenação de Extensão CCS" },
        { codigo: 35001100, label: "Coordenação de Integração Acadêmica/CCS" },
        { codigo: 35009000, label: "Seção de Pessoal/CCS" },
        { codigo: 35009001, label: "Setor de Processamento de Dados -Pess/CCS" },
        { codigo: 35009100, label: "Seção Financeira/CCS" },
        { codigo: 35009101, label: "Setor de Atualização SIAFI/CCS" },
        { codigo: 35009200, label: "Seção de Ensino/CCS" },
        { codigo: 35009300, label: "Administração da Sede/CCS" },
        { codigo: 35009400, label: "Seção de Comunicação e Protocolo /CCS" },
        { codigo: 35009500, label: "Seção de Material/CCS" },
        { codigo: 35009600, label: "Oficinas de Manutenção/CCS" },
        { codigo: 35009700, label: "Almoxarifado/CCS" },
        { codigo: 35009800, label: "Atividades Gerenciais CCS" },
        { codigo: 35010100, label: "Departamento de Patologia/FM" },
        { codigo: 35010200, label: "Departamento de Clínica Médica/FM" },
        { codigo: 35010300, label: "Departamento de Cirurgia/FM" },
        { codigo: 35010310, label: "Laboratório de Cirurgia Experimental/FM" },
        { codigo: 35010400, label: "Departamento de Otorrino e Oftalmologia/FM" },
        { codigo: 35010500, label: "Departamento de Ginecologia e Obstetricia/FM" },
        { codigo: 35010600, label: "Departamento de Ortopedia e Traumatologia/FM" },
        { codigo: 35010700, label: "Departamento de Pediatria/FM" },
        { codigo: 35010800, label: "Departamento de Medicina Preventiva/FM" },
        { codigo: 35010900, label: "Departamento de Psiquiatria e Medicina Legal/FM" },
        { codigo: 35011000, label: "Departamento de Radiologia/FM" },
        { codigo: 35011100, label: "Departamento de Medicina de Família e Comunidade/FM" },
        { codigo: 35011200, label: "Departamento de Fonoaudiologia/FM" },
        { codigo: 35011300, label: "Departamento de Fisioterapia/FM" },
        { codigo: 35011400, label: "Departamento de Terapia Ocupacional/FM" },
        { codigo: 35018900, label: "Gabinete do Diretor da Faculdade de Medicina" },
        { codigo: 35019000, label: "Seção de Atividades Gerenciais FM/CCS" },
        { codigo: 35019010, label: "Seção de Pessoal FM/CCS" },
        { codigo: 35019020, label: "Seção Financeira FM/CCS" },
        { codigo: 35019030, label: "Protocolo FM/CCS" },
        { codigo: 35019100, label: "Secretaria Acadêmica FM/CCS" },
        { codigo: 35019110, label: "Secretaria de Ensino de Graduação FM/CCS" },
        { codigo: 35019120, label: "Secretaria de Ensino de Pós-Graduação FM/CCS" },
        { codigo: 35019200, label: "Administração da Sede FM/CCS" },
        { codigo: 35019400, label: "Gabinete de Radiologia/FM" },
        { codigo: 35020100, label: "Departamento de Patogia e Diagnóstico Oral/FO" },
        { codigo: 35020200, label: "Departamento de Clínica Odontológica/FO" },
        { codigo: 35020300, label: "Departamento de Prótese/FO" },
        { codigo: 35020400, label: "Departamento de Ortodontia e Odontopediatria/FO" },
        { codigo: 35020500, label: "Departamento de Odontologia Social e Preventiva/FO" },
        { codigo: 35020509, label: "Setor de Serviço Social" },
        { codigo: 35020510, label: "Setor de Esterilização" },
        { codigo: 35029000, label: "Seção de Atividades Gerenciais Od/CCS" },
        { codigo: 35029010, label: "Seção de Pessoal Od/CCS" },
        { codigo: 35029020, label: "Seção Financeira Od/CCS" },
        { codigo: 35029110, label: "Secretaria de Ensino de Graduação Od/CCS" },
        { codigo: 35029120, label: "Secretaria de Ensino de Pós-Graduação Od/CCS" },
        { codigo: 35029200, label: "Administração da Sede Od/CCS" },
        { codigo: 35029300, label: "Serviço de Radiologia/Fac Odont" },
        { codigo: 35030500, label: "Departamento de Análise Clínica e Toxicologica" },
        { codigo: 35030600, label: "Departamento de Fármacos e Medicamentos" },
        { codigo: 35030700, label: "Departamento de Biotecnologia Farmacêutica" },
        { codigo: 35030800, label: "Departamento de Produtos Naturais e Alimentos" },
        { codigo: 35038900, label: "Gabinete do Diretor da Faculdade de Farmácia" },
        { codigo: 35039000, label: "Seção de Atividades Gerenciais FF/CCS" },
        { codigo: 35039010, label: "Seção de Pessoal FF/CCS" },
        { codigo: 35039020, label: "Seção Financeira FF/CCS" },
        { codigo: 35039100, label: "Secretaria Acadêmica FF/CCS" },
        { codigo: 35039120, label: "Secretaria de Ensino de Pós-Graduação FF/CCS" },
        { codigo: 35039200, label: "Administração da Sede FF/CCS" },
        { codigo: 35039210, label: "Setor de Protocolo FF/CCS" },
        { codigo: 35040100, label: "Departamento de Enfermagem Fundamental/EEAN" },
        { codigo: 35040200, label: "Departamento de Enfermagem e Medicina Cirúrgica/EEAN" },
        { codigo: 35040300, label: "Departamento de Enfermagem  Materno-Infantil/EEAN" },
        { codigo: 35040400, label: "Departamento de Metodologia da Enfermagem/EEAN" },
        { codigo: 35040500, label: "Departamento de Enfermagem e Saúde Pública/EEAN" },
        { codigo: 35040700, label: "Centro de Documentação em Enfermagem/EEAN" },
        { codigo: 35048900, label: "Gabinete do Diretor da Escola de Enfermagem/EEAN" },
        { codigo: 35049000, label: "Seção de Atividades Gerenciais EEAN/CCS" },
        { codigo: 35049010, label: "Seção de Pessoal EEAN/CCS" },
        { codigo: 35049020, label: "Seção Financeira EEAN/CCS" },
        { codigo: 35049030, label: "Setor de Protocolo/EEAN" },
        { codigo: 35049050, label: "Setor de Compras/Eean" },
        { codigo: 35049060, label: "Almoxarifado/Eean" },
        { codigo: 35049110, label: "Secretaria de Ensino de Graduação EAN/CCS" },
        { codigo: 35049120, label: "Secretaria de Ensino de Pós-Graduação EAN/CCS" },
        { codigo: 35049200, label: "Administração da Sede EEAN/CCS" },
        { codigo: 35049300, label: "Serviço de Enfermagem EEAN/CCS" },
        { codigo: 35050001, label: "Instituto de Ciências Biomédicas - ICB" },
        { codigo: 35050100, label: "Departamento de Histologia e Embriologia/ICB" },
        { codigo: 35050200, label: "Departamento de Anatomia/ICB" },
        { codigo: 35050300, label: "Departamento de Bioquímica/ICB" },
        { codigo: 35050600, label: "Departamento de Farmácologia Básica e Clínica" },
        { codigo: 35051000, label: "Diretoria Adjunta de Graduação - ICB" },
        { codigo: 35051001, label: "Secretaria da Diretoria Adjunta de Graduação - ICB" },
        { codigo: 35051100, label: "Diretoria Adjunta de Pesquisa - ICB" },
        { codigo: 35051200, label: "Diretoria Adjunta de Extensão - ICB" },
        { codigo: 35051300, label: "Diretoria Adjunta de Pós-graduação - ICB" },
        { codigo: 35051302, label: "Programa de Pós-graduação em Farmacologia e Quím. Med. - ICB" },
        { codigo: 35051303, label: "Programa de Pós-graduação em em Ciências Morfológicas - ICB" },
        { codigo: 35051400, label: "Técnico Administrativos - ICB" },
        { codigo: 35051500, label: "Docentes - ICB" },
        { codigo: 35058900, label: "Gabinete do Diretor ICB" },
        { codigo: 35059000, label: "Coordenação de Atividades Gerenciais - ICB" },
        { codigo: 35059010, label: "Seção de Gestão de Pessoas - ICB" },
        { codigo: 35059020, label: "Seção Financeira - ICB" },
        { codigo: 35059030, label: "Seção de Compras - ICB" },
        { codigo: 35059050, label: "Seção de Almoxarifado e Patrimônio - ICB" },
        { codigo: 35059110, label: "Secretaria de Ensino de Graduação ICB/CCS" },
        { codigo: 35060100, label: "Departamento de Microbiologia Geral/IM" },
        { codigo: 35060200, label: "Departamento de Microbiologia Médica/IM" },
        { codigo: 35060300, label: "Departamento de Imunologia/IM" },
        { codigo: 35060400, label: "Departamento de Virologia/IM" },
        { codigo: 35068900, label: "Gabinete do Diretor do Instituto de Microbiologia" },
        { codigo: 35069000, label: "Seção de Atividades Gerenciais IM/CCS" },
        { codigo: 35069010, label: "Seção de Pessoal IM/CCS" },
        { codigo: 35069020, label: "Seção Financeira IM/CCS" },
        { codigo: 35069100, label: "Secretaria Acadêmica IM/CCS" },
        { codigo: 35069101, label: "Setor de Microscopia Eletrônica/IM" },
        { codigo: 35069102, label: "Biotério do IM/CCS" },
        { codigo: 35069200, label: "Administração da Sede IM/CCS" },
        { codigo: 35069300, label: "Serviço de Microbiologia Geral/IM" },
        { codigo: 35069400, label: "Serviço de Microbiologia Médica/IM" },
        { codigo: 35069500, label: "Serviço de Imunologia/IM" },
        { codigo: 35069800, label: "Setor de Epidemiologias de Doenças Infecciosas / IM" },
        { codigo: 35070200, label: "Departamento de Nutrição Social Aplicada/I Nutr" },
        { codigo: 35070300, label: "Departamento de Nutrição Básica Experimental/I Nutr" },
        { codigo: 35070400, label: "Departamento de Nutrição Dietética/I Nutr" },
        { codigo: 35075000, label: "Laboratórios / Nutrição" },
        { codigo: 35075001, label: "Laboratório de Ciência Alimentícia/Nutri" },
        { codigo: 35075002, label: "Laboratório de Tecnologia Alimentar/Nutri" },
        { codigo: 35075004, label: "Laboratório de Bioquímica e Fisiologia Alimentar/Nutri" },
        { codigo: 35078900, label: "Gabinete do Diretor do Instituto de Nutrição" },
        { codigo: 35079000, label: "Seção de Atividades Gerenciais Nutr/CCS" },
        { codigo: 35079010, label: "Seção de Pessoal Nutr/CCS" },
        { codigo: 35079020, label: "Seção Financeira Nutr/CCS" },
        { codigo: 35079110, label: "Secretaria de Ensino de Graduação Nutr/CCS" },
        { codigo: 35079120, label: "Secretaria de Ensino de Pós-Graduação Nutr/CCS" },
        { codigo: 35079200, label: "Administração da Sede Nutr/CCS" },
        { codigo: 35080100, label: "Programa de Biofísica/I Biof" },
        { codigo: 35080300, label: "Programa Neurobiologia/Biof" },
        { codigo: 35080303, label: "Laboratório de Neurofisiologia Aristides Pacheco Leão/I Biof" },
        { codigo: 35080304, label: "Laboratório de Fisiologia da Cognação/I Biof" },
        { codigo: 35080305, label: "Laboratório de Neurobiologia 2/Biof" },
        { codigo: 35080307, label: "Laboratório de Neurobiologia Retina/Biof" },
        { codigo: 35080308, label: "Laboratório de Neurobiologia e Desenvolvimento/Biof" },
        { codigo: 35080309, label: "Laboratório de Neurogênese/Biof" },
        { codigo: 35080311, label: "Laboratório de Neurobiologia Celular e Molecular/Biof" },
        { codigo: 35080312, label: "Laboratório de Neuroquímica/Biof" },
        { codigo: 35080400, label: "Programa de Biologia Molecular e Estrutural/Biof" },
        { codigo: 35080402, label: "Laboratório de Biologia Molecular de Vírus/Biof" },
        { codigo: 35080405, label: "Laboratório de Unidade Multidisciplinar de Genômica/Biof" },
        { codigo: 35080406, label: "Laboratório de Metabolismo Macromolecular/I Biof" },
        { codigo: 35080407, label: "Laboratório de Parasitologia Molecular/Biof" },
        { codigo: 35080410, label: "Laboratório de Radiobiologia Molecular/I Biof" },
        { codigo: 35080411, label: "Unidade Citogenética/ I Biof" },
        { codigo: 35080500, label: "Programa de Imunobiologia/Biof" },
        { codigo: 35080502, label: "Laboratório de Imunobiologia Molecular/Biof" },
        { codigo: 35080503, label: "Laboratório de Imunobiologia Parasitária/Biof" },
        { codigo: 35080504, label: "Laboratório de Imunobiofísica/Biof" },
        { codigo: 35080506, label: "Laboratório de Imunofarmacologia/Biof" },
        { codigo: 35080507, label: "Laboratório de Biologia Imunitária" },
        { codigo: 35080601, label: "Laboratório de Biofísica e Radiações/Biof" },
        { codigo: 35080604, label: "Laboratório de Radioisótopos Eduardo Penna Franca/I Biof" },
        { codigo: 35080702, label: "Laboratório de Eletrofisiologia Cardíaca/Biof" },
        { codigo: 35080705, label: "Laboratório de Membranas Excitáveis/Biof" },
        { codigo: 35080800, label: "Programa de Fisiologia e Biofísica Celular/Biof" },
        { codigo: 35080801, label: "Laboratório de Fisiologia da Respiracao/Biof" },
        { codigo: 35080802, label: "Laboratório de Fisiologia e Endocrinologia/Biof" },
        { codigo: 35080803, label: "Laboratório de Fisiologia Renal/Biof" },
        { codigo: 35080807, label: "Laboratório Físico-Química Biológica" },
        { codigo: 35080808, label: "Laboratório de Cardiologia Celular e Molecular/Biof" },
        { codigo: 35080900, label: "Programa de Biologia Celular e Parasitária/Biof" },
        { codigo: 35080901, label: "Unidade de Citogenética/Biof" },
        { codigo: 35080902, label: "Laboratório de Entomologia Médica/Biof" },
        { codigo: 35080906, label: "Laboratório de Ultraestrutura Celular Hertha Meyer/I Biof" },
        { codigo: 35080909, label: "Laboratório de Glicobiologia/Biof" },
        { codigo: 35088900, label: "Gabinete do Diretor do Instituto de Biofísica" },
        { codigo: 35089000, label: "Seção de Atividades Gerenciais BF/CCS" },
        { codigo: 35089010, label: "Seção de Pessoal BF/CCS" },
        { codigo: 35089020, label: "Seção Financeira BF/CCS" },
        { codigo: 35089100, label: "Secretaria Acadêmica BF/CCS" },
        { codigo: 35089110, label: "Secretaria de Ensino de Pós-Graduação BF/CCS" },
        { codigo: 35089200, label: "Administração da Sede BF/CCS" },
        { codigo: 35089700, label: "Serviço de Biofísica Celular/I Biof" },
        { codigo: 35090100, label: "Programa de Produtos Naturais/IPPN" },
        { codigo: 35098900, label: "Gabinete do Diretor do IPPN" },
        { codigo: 35099300, label: "Seção de Atividades Gerenciais IPPN" },
        { codigo: 35099310, label: "Seção de Pessoal IPPN" },
        { codigo: 35100100, label: "Programa de Ginecologia/I Ginec" },
        { codigo: 35101000, label: "Setor de Anatomia e Patologia/Ginec" },
        { codigo: 35101100, label: "Setor de Cobaltoterapia/Ginec" },
        { codigo: 35101200, label: "Setor de Psicologia/Ginec" },
        { codigo: 35101300, label: "Serviço Social / Ginec" },
        { codigo: 35101400, label: "Centro Cirúrgico  / Ginec" },
        { codigo: 35108900, label: "Gabinete do Diretor do Instituto de Ginecologia" },
        { codigo: 35109000, label: "Seção de Atividades Gerenciais Gin/CCS" },
        { codigo: 35109010, label: "Seção de Pessoal Ginec" },
        { codigo: 35109020, label: "Seção Financeira Ginec" },
        { codigo: 35109110, label: "Secretaria de Ensino de Pós-Graduação Ginec/CCS" },
        { codigo: 35109200, label: "Administração da Sede Gin/CCS" },
        { codigo: 35109400, label: "Serviço de Enfermagem/I Ginec" },
        { codigo: 35118900, label: "Gabinete do Diretor do Instituto de Neurologia" },
        { codigo: 35119000, label: "Seção de Atividades Gerenciais IN/CCS" },
        { codigo: 35119010, label: "Seção de Pessoal IN/CCS" },
        { codigo: 35119020, label: "Seção Financeira IN/CCS" },
        { codigo: 35119110, label: "Secretaria de Ensino de Pós-Graduação IN/CCS" },
        { codigo: 35119200, label: "Administração da Sede IN/CCS" },
        { codigo: 35119300, label: "Serviço de Apoio Administrativo IN/CCS" },
        { codigo: 35119400, label: "Serviço de Enfermagem IN/CCS" },
        { codigo: 35119500, label: "Serviço de Enfermagem Cirúrgica IN/CCS" },
        { codigo: 35119700, label: "Serviço de Administração Hospitalar IN/CCS" },
        { codigo: 35119800, label: "Serviço Médico IN/CCS" },
        { codigo: 35120100, label: "Programa de Psiquiatria / IPUB" },
        { codigo: 35120101, label: "Secretaria de Mestrado Profissional / IPUB" },
        { codigo: 35121000, label: "Ambulatório Geral / IPUB" },
        { codigo: 35121100, label: "Hospital Dia / IPUB" },
        { codigo: 35121200, label: "Oficina Atelier da Vida / IPUB" },
        { codigo: 35121300, label: "Laboratório / IPUB" },
        { codigo: 35128900, label: "Gabinete da Diretoria / IPUB" },
        { codigo: 35129000, label: "Seção de Atividades Gerenciais / IPUB" },
        { codigo: 35129010, label: "Seção de Pessoal / IPUB" },
        { codigo: 35129020, label: "Setor Financeiro / IPUB" },
        { codigo: 35129030, label: "Setor de Faturamento / IPUB" },
        { codigo: 35129040, label: "Setor de Compras / IPUB" },
        { codigo: 35129050, label: "Setor de Protocolo / IPUB" },
        { codigo: 35129060, label: "Setor Audiovisual / IPUB" },
        { codigo: 35129070, label: "Setor Almoxarifado / IPUB" },
        { codigo: 35129080, label: "Setor Núcleo de Vídeo / IPUB" },
        { codigo: 35129100, label: "Secretaria Acadêmica / IPUB" },
        { codigo: 35129110, label: "Secretaria de Ensino de Pós-Graduação / IPUB" },
        { codigo: 35129200, label: "Administração da Sede / IPUB" },
        { codigo: 35129210, label: "Serviço de Nutrição / IPUB" },
        { codigo: 35129300, label: "Serviço de Assistência Psiquiátrica / IPUB" },
        { codigo: 35129301, label: "Ambulatório Carim / IPUB" },
        { codigo: 35129302, label: "Ambulatório Spia / IPUB" },
        { codigo: 35129303, label: "Setor de Farmácia / IPUB" },
        { codigo: 35129305, label: "Centro de Doenças de Alzheimer / IPUB" },
        { codigo: 35129306, label: "Projad / IPUB" },
        { codigo: 35129307, label: "Serviço Social / IPUB" },
        { codigo: 35129308, label: "Núcleo de Pesquisa em Políticas Públicas de Saúde Mental" },
        { codigo: 35129309, label: "Grupo de Obesidade e Transtornos Alimentares/IPUB" },
        { codigo: 35129400, label: "Setor de Enfermagem Masculino / IPUB" },
        { codigo: 35129500, label: "Setor de Enfermagem Feminino / IPUB" },
        { codigo: 35129600, label: "Biblioteca Setorial / IPUB" },
        { codigo: 35130100, label: "Programa de Pediatria/I Pueric" },
        { codigo: 35138900, label: "Gabinete do Diretor do Instituto de Puericultura" },
        { codigo: 35139000, label: "Seção de Atividades Gerenciais IPPMG/CCS" },
        { codigo: 35139010, label: "Seção de Pessoal IPPMG" },
        { codigo: 35139020, label: "Seção Financeira IPPMG" },
        { codigo: 35139100, label: "Secretaria Acadêmica IPPMG/CCS" },
        { codigo: 35139110, label: "Secretaria de Ensino de Pós-Graduação IPPMG" },
        { codigo: 35139200, label: "Administração da Sede IPPMG/CCS" },
        { codigo: 35139300, label: "Serviço de Pacientes Internos IPPMG" },
        { codigo: 35139400, label: "Serviço de Pacientes Externos IPPMG" },
        { codigo: 35139500, label: "Serviço de Apoio Assistêncial IPPMG" },
        { codigo: 35139600, label: "Serviço de Pesquisas IPPMG/CCS" },
        { codigo: 35139700, label: "Serviço de Saúde Comunitária IPPMG" },
        { codigo: 35139800, label: "Serviço de Apoio e Diagnóstico IPPMG" },
        { codigo: 35140500, label: "Gabinete do Diretor/Idt" },
        { codigo: 35141000, label: "Coordenação de Ensino e Pesquisa/Idt" },
        { codigo: 35141501, label: "Biblioteca/Idt" },
        { codigo: 35142000, label: "Serviço de Clínica/Idt" },
        { codigo: 35142002, label: "Ambulatório/Idt" },
        { codigo: 35142500, label: "Serviço de Cirurgia Torácica/Idt" },
        { codigo: 35143000, label: "Serviço de Patologia Clínica/Idt" },
        { codigo: 35143500, label: "Serviço de Fisiopatologia Cardiopulmonar/Idt" },
        { codigo: 35144000, label: "Serviço de Bacteriologia/Idt" },
        { codigo: 35144500, label: "Serviço de Patologia/Idt" },
        { codigo: 35145000, label: "Serviço de Radiodiagnóstico/Idt" },
        { codigo: 35145500, label: "Serviço de Enfermagem/Idt" },
        { codigo: 35146502, label: "Setor de Serviço Social/Idt" },
        { codigo: 35147000, label: "Seção de Atividades Gerenciais/Idt" },
        { codigo: 35147001, label: "Seção Financeira/Idt" },
        { codigo: 35147004, label: "Seção de Pessoal/Idt" },
        { codigo: 35149000, label: "Seção de Atividades Gerenciais Idt/CCS" },
        { codigo: 35149010, label: "Seção de Pessoal Idt/CCS" },
        { codigo: 35155000, label: "Departamento de Recursos Humanos/HESFA" },
        { codigo: 35158900, label: "Gabinete do Diretor/HESFA" },
        { codigo: 35159000, label: "Secretaria do HESFA" },
        { codigo: 35159200, label: "Administração da Sede/HESFA" },
        { codigo: 35159300, label: "Serviço de Enfermagem/HESFA" },
        { codigo: 35159400, label: "Centro Cirúrgico/HESFA" },
        { codigo: 35159500, label: "Farmácia do HESFA" },
        { codigo: 35159600, label: "Laboratório do HESFA" },
        { codigo: 35185100, label: "Departamento de Arte Corporal/EEFD" },
        { codigo: 35185200, label: "Departamento de Corridas/EEFD" },
        { codigo: 35185300, label: "Departamento de Ginástica/EEFD" },
        { codigo: 35185400, label: "Departamento de Jogos/EEFD" },
        { codigo: 35185500, label: "Departamento de Lutas/EEFD" },
        { codigo: 35188900, label: "Gabinete do Diretor EEFD" },
        { codigo: 35189000, label: "Secretaria da EEFD" },
        { codigo: 35189100, label: "Seção de Ensino/EEFD" },
        { codigo: 35189110, label: "Secretaria de Ensino de Graduação EEFD" },
        { codigo: 35189120, label: "Secretaria de Ensino de Pós-Graduação EEFD" },
        { codigo: 35189200, label: "Administração da Sede/EEFD" },
        { codigo: 35189210, label: "Manutenção / EEFD" },
        { codigo: 35189300, label: "Campo Desportivo/EEFD" },
        { codigo: 35189400, label: "Departamento de Biociências e Atividades Físicas /EEFD" },
        { codigo: 35189500, label: "Seção de Atividades Gerenciais EEFD" },
        { codigo: 35189510, label: "Seção de Pessoal EEFD" },
        { codigo: 35189520, label: "Seção Financeira EEFD" },
        { codigo: 35189530, label: "Seção de Patrimônio" },
        { codigo: 35189540, label: "Seção de Protocolo EEFD" },
        { codigo: 35190100, label: "Departamento Biologia Marinha/IB" },
        { codigo: 35190101, label: "Laboratório de Hidrobiologia/IB" },
        { codigo: 35190102, label: "Laboratório de Benthos / IB" },
        { codigo: 35190105, label: "Laboratório de Microbiologia Marinha/IB" },
        { codigo: 35190107, label: "Laboratório de Recursos Pesqueiros/IB" },
        { codigo: 35190200, label: "Departamento de Botânica/IB" },
        { codigo: 35190203, label: "Laboratório de Fisiologia / IB" },
        { codigo: 35190206, label: "Laboratório de Algas / IB" },
        { codigo: 35190208, label: "Herbário / IB" },
        { codigo: 35190300, label: "Departamento de Ecologia/IB" },
        { codigo: 35190301, label: "Laboratório de Limologia / IB" },
        { codigo: 35190303, label: "Laboratório de Ecologia de Insetos / IB" },
        { codigo: 35190307, label: "Laboratório de Mamíferos / IB" },
        { codigo: 35190308, label: "Laboratório de Ecologia da Comunidade/IB" },
        { codigo: 35190400, label: "Departamento de Genética/IB" },
        { codigo: 35190402, label: "Laboratório de Genética Molecular Vegetal/IB" },
        { codigo: 35190403, label: "Laboratório de Genética Molecular/IB" },
        { codigo: 35190404, label: "Laboratório de Genética Molecular 2/IB" },
        { codigo: 35190405, label: "Laboratório de Virologia Molecular Animal/IB" },
        { codigo: 35190406, label: "Laboratório de Malformações Congênitas/IB" },
        { codigo: 35190410, label: "Laboratório de Genética de Populações de Drosophila/IB" },
        { codigo: 35190411, label: "Laboratório de Genética Marinha / IB" },
        { codigo: 35190500, label: "Departamento de Zoologia/IB" },
        { codigo: 35190502, label: "Laboratório de Ictioplâncton / IB" },
        { codigo: 35190506, label: "Laboratório de Sistemática/Evolução de Peixes Teleósteos/IB" },
        { codigo: 35190507, label: "Laboratório de Carcinologia / IB" },
        { codigo: 35190508, label: "Laboratório de Ornitologia / IB" },
        { codigo: 35190509, label: "Laboratório de Entomologia / IB" },
        { codigo: 35190510, label: "Laboratório de Anfíbios e Répteis/IB" },
        { codigo: 35190512, label: "Laboratório de Mastozoologia / IB" },
        { codigo: 35190513, label: "Laboratório de Protistologia / IB" },
        { codigo: 35190515, label: "Laboratório de Polychaeta / IB" },
        { codigo: 35198900, label: "Gabinete do Diretor do Instituto de Biologia" },
        { codigo: 35199000, label: "Seção de Atividades Gerenciais IB/CCS" },
        { codigo: 35199010, label: "Seção de Pessoal IB/CCS" },
        { codigo: 35199020, label: "Seção Financeira IB/CCS" },
        { codigo: 35199030, label: "Protocolo IB/CCS" },
        { codigo: 35199040, label: "Setor de Informática/IB" },
        { codigo: 35199110, label: "Secretaria de Ensino de Graduação IB/CCS" },
        { codigo: 35199120, label: "Secretaria de Ensino de Pós-Graduação IB/CCS" },
        { codigo: 35199200, label: "Administração da Sede IB/CCS" },
        { codigo: 35208000, label: "Setor de Enfermagem / Matesc" },
        { codigo: 35208100, label: "Farmácia / Matesc" },
        { codigo: 35208200, label: "Arquivo Médico / Matesc" },
        { codigo: 35208300, label: "Laboratório de Análises Clínicas/Matesc" },
        { codigo: 35208400, label: "Laboratório de Anatomia Patológica/Matesc" },
        { codigo: 35208900, label: "Gabinete do Diretor da Maternidade Escola" },
        { codigo: 35209000, label: "Secretaria da Maternidade Escola" },
        { codigo: 35209100, label: "Administração da Sede da Maternidade Escola" },
        { codigo: 35209110, label: "Refeitório / Matesc" },
        { codigo: 35209210, label: "Seção de Pessoal Matesc" },
        { codigo: 35209220, label: "Seção Financeira Matesc" },
        { codigo: 35209300, label: "Biblioteca Setorial / Matesc" },
        { codigo: 35217000, label: "Setor de Ensino e Pesquisa/NUTES" },
        { codigo: 35218900, label: "Gabinete do Diretor do NUTES" },
        { codigo: 35219300, label: "Setor de Computação/NUTES" },
        { codigo: 35219500, label: "Setor de Produção Áudiovisual/NUTES" },
        { codigo: 35219700, label: "Seção de Atividades Gerenciais NUTES" },
        { codigo: 35219710, label: "Seção de Pessoal NUTES" },
        { codigo: 35219720, label: "Seção Financeira NUTES" },
        { codigo: 35219730, label: "Administração da Sede NUTES" },
        { codigo: 35219800, label: "Biblioteca Setorial NUTES" },
        { codigo: 35220100, label: "Gabinete do Diretor do Iesc" },
        { codigo: 35220101, label: "Coordenação Acadêmica de Estágio Multiprofissional/IESC" },
        { codigo: 35220200, label: "Secretaria do Iesc" },
        { codigo: 35220500, label: "Gerencia de Informação" },
        { codigo: 35220600, label: "Coordenação de Ensino/Iesc" },
        { codigo: 35220700, label: "Coordenação de Pesquisa/Iesc" },
        { codigo: 35220800, label: "Coordenação de Extensão/Iesc" },
        { codigo: 35229000, label: "Seção de Atividades Gerenciais Iesc" },
        { codigo: 35229010, label: "Seção de Pessoal Iesc" },
        { codigo: 35229100, label: "Administração da Sede Iesc/CCS" },
        { codigo: 35229200, label: "Secretaria Acadêmica - IESC" },
        { codigo: 35229210, label: "Secretaria de Ensino de Graduação - IESC" },
        { codigo: 35229220, label: "Secretaria Academica de Pos-Graduação - IESC" },
        { codigo: 35230100, label: "Programa de Biologia Celular e Biofisica" },
        { codigo: 35230200, label: "Programa de Biologia Molecular e Biotecnologia" },
        { codigo: 35230300, label: "Programa de Biologia Estrutural" },
        { codigo: 35230400, label: "Programa de Glicobiologia" },
        { codigo: 35230500, label: "Programa de Educação, Gestão e Difusão" },
        { codigo: 35238900, label: "Gabinete do Diretor do Instituto de Bioquímica Médica" },
        { codigo: 35239000, label: "Direção Adjunta de Gestão Administrativa - IBqM" },
        { codigo: 35239010, label: "Seção de Pessoal" },
        { codigo: 35239020, label: "Seção Financeira" },
        { codigo: 35239040, label: "Seção de Compras" },
        { codigo: 35239100, label: "Direção Adjunta de Graduação - IBqM" },
        { codigo: 35239201, label: "Coordenação de Pós-Graduação Química Biológica - IBqM" },
        { codigo: 35240003, label: "Núcleo de Pesquisas Ecológicas de Macaé - NUPEM - Docentes" },
        { codigo: 35248900, label: "Gabinete do Diretor do NUPEM" },
        { codigo: 35249310, label: "Seção de Pessoal / NUPEM" },
        { codigo: 35249320, label: "Seção Financeira / NUPEM" },
        { codigo: 35250001, label: "Gabinete do Diretor - ICES" },
        { codigo: 35259100, label: "Serviço Financeiro - ICES" },
        { codigo: 35259300, label: "Seção de Recursos Humanos - ICES" },
        { codigo: 35260100, label: "Protocolo / CENABIO" },
        { codigo: 35261000, label: "Gabinete da Direção / CENABIO" },
        { codigo: 35262000, label: "Coordenadoria do Centro Nacional de RMN Jiri Jonas / CENABIO" },
        { codigo: 35263000, label: "Coordenadoria da Unidade de Microscopia / CENABIO" },
        { codigo: 35264000, label: "Diretoria Adjunta de Ensino, Pesquisa e Extensão / CENABIO" },
        { codigo: 35265000, label: "Coord da Unidade de Bioimagem de Pequenos Animais / CENABIO" },
        { codigo: 35266000, label: "Diretoria Adjunta de Administração / CENABIO" },
        { codigo: 35266020, label: "Setor Financeiro / CENABIO" },
        { codigo: 35266050, label: "Setor de Pessoal / CENABIO" },
        { codigo: 35266060, label: "Setor de Compras/CENABIO" },
        { codigo: 35270100, label: "Gabinete da Direção - NUBEA" },
        { codigo: 35270300, label: "Seção de Pessoal - NUBEA" },
        { codigo: 35270400, label: "Coordenação de Ensino/NUBEA" },
        { codigo: 36000100, label: "Decania do CT" },
        { codigo: 36000200, label: "Escritório de Planejamento/CT" },
        { codigo: 36000400, label: "Gabinete do Superintendente do CT" },
        { codigo: 36000500, label: "Secretaria do CT" },
        { codigo: 36000600, label: "Biblioteca do CT" },
        { codigo: 36000800, label: "Setor de Integração e Aperfeiçoamento de Pessoal/CT" },
        { codigo: 36000900, label: "Setor de Qualidade de Vida do Trabalhador/CT" },
        { codigo: 36001000, label: "Sistema de Gestão Integrado/CT" },
        { codigo: 36001100, label: "Seção de Tecnologia da Informação/CT" },
        { codigo: 36001200, label: "Assessoria de Comunicação/CT" },
        { codigo: 36001300, label: "Seção de Licitação/CT" },
        { codigo: 36001400, label: "Biblioteca de Obras Raras/CT" },
        { codigo: 36009000, label: "Seção de Pessoal/CT" },
        { codigo: 36009100, label: "Seção Financeira/CT" },
        { codigo: 36009200, label: "Seção de Ensino/CT" },
        { codigo: 36009300, label: "Administração da Sede/CT" },
        { codigo: 36009400, label: "Seção de Protocolo /CT" },
        { codigo: 36009500, label: "Seção de Material/CT" },
        { codigo: 36009600, label: "Serviço de Manutenção Técnica/CT" },
        { codigo: 36009700, label: "Almoxarifado/CT" },
        { codigo: 36010100, label: "Departamento de Expressão Gráfica/Poli" },
        { codigo: 36010400, label: "Departamento de Engenharia Mecânica /Poli" },
        { codigo: 36010402, label: "Laboratório de Trasmicao Tecnologica de Calor Dem/Poli" },
        { codigo: 36010403, label: "Laboratório de Tecnologia Mecânica Dem/Poli" },
        { codigo: 36010500, label: "Departamento de Eletrônica/Poli" },
        { codigo: 36010501, label: "Laboratório de Eletrônica Del/Poli" },
        { codigo: 36010504, label: "Laboratório de Desenvolvimento - Del/Poli" },
        { codigo: 36010600, label: "Departamento de Engenharia Elétrica / Poli" },
        { codigo: 36010601, label: "Laboratório de Acionamento e Controle Dee/Poli" },
        { codigo: 36010602, label: "Laboratório de Circuitos - Dee/Poli" },
        { codigo: 36010603, label: "Laboratório de Máquinas Elétricas Dee/Poli" },
        { codigo: 36010700, label: "Departamento de Engenharia Nava/Poli" },
        { codigo: 36010701, label: "Laboratório de Computação DEN/Poli" },
        { codigo: 36010800, label: "Departamento de Engenharia Metalúrgica/Poli" },
        { codigo: 36010801, label: "Laboratório de Propriedades Mecânicas Dmt/Poli" },
        { codigo: 36010900, label: "Departamento de Engenharia Nuclear/Poli" },
        { codigo: 36010901, label: "Laboratório de Instrumentação Nuclear Dnc/Poli" },
        { codigo: 36011000, label: "Departamento de Engenharia Industrial/Poli" },
        { codigo: 36011100, label: "Departamento de Recursos Hídricos e Meio Ambiente / Poli" },
        { codigo: 36011101, label: "Laboratório de Engenharia de Meio Ambiente Dhs/Poli" },
        { codigo: 36011300, label: "Departamento de Transportes/Poli" },
        { codigo: 36011400, label: "Departamento de Construção Civil/Poli" },
        { codigo: 36011401, label: "Laboratório de Materiais de Construção Dcc/Poli" },
        { codigo: 36011500, label: "Departamento de Estruturas" },
        { codigo: 36011600, label: "Departamento de Engenharia Ambiental/Poli" },
        { codigo: 36011700, label: "Departamento de Engenharia Civil/Poli" },
        { codigo: 36011800, label: "Departamento de Engenharia Computação e Informação/Poli" },
        { codigo: 36011900, label: "Departamento de Engenharia Controle e Automação/Poli" },
        { codigo: 36012000, label: "Departamento de Engenharia do Petróleo/Poli" },
        { codigo: 36013000, label: "Diretoria Adjunta de Desenvolvimento e Extensão/Poli" },
        { codigo: 36014100, label: "Seção de Compras/Poli" },
        { codigo: 36018900, label: "Gabinete do Diretor da Escola de Politécnica" },
        { codigo: 36019000, label: "Seção de Atividades Gerenciais  Poli / CT" },
        { codigo: 36019010, label: "Seção de Pessoal Poli / CT" },
        { codigo: 36019020, label: "Seção Financeira Poli / CT" },
        { codigo: 36019100, label: "Secretaria Acadêmica Poli / CT" },
        { codigo: 36019200, label: "Administração da Sede Poli / CT" },
        { codigo: 36020100, label: "Departamento de Engenharia Química/EQ" },
        { codigo: 36020200, label: "Departamento de Engenharia Bioquímica/EQ" },
        { codigo: 36020300, label: "Departamento de Processos Inorgânicos/EQ" },
        { codigo: 36020400, label: "Departamento de Processos Orgânicos/EQ" },
        { codigo: 36028900, label: "Gabinete do Diretor da Escola de Química" },
        { codigo: 36029000, label: "Seção de Atividades Gerenciais EQ/CT" },
        { codigo: 36029010, label: "Seção de Pessoal EQ/CT" },
        { codigo: 36029020, label: "Seção Financeira EQ/CT" },
        { codigo: 36029100, label: "Secretaria Acadêmica de Ensino e Graduação EQ/CT" },
        { codigo: 36029120, label: "Secretaria de Ensino de Pós-Graduação EQ/CT" },
        { codigo: 36029200, label: "Administração Sede EQ/CT" },
        { codigo: 36030100, label: "Programa de Engenharia Química/COPPE" },
        { codigo: 36030101, label: "Laboratório de Membranas - Peq/COPPE" },
        { codigo: 36030102, label: "Laboratório do Núcleo de Catálise - Peq/COPPE" },
        { codigo: 36030103, label: "Laboratório de Termofluido - Peq/COPPE" },
        { codigo: 36030200, label: "Programa de Engenharia Mecânica/COPPE" },
        { codigo: 36030202, label: "Laboratório de Robótica - Pem/COPPE" },
        { codigo: 36030203, label: "Laboratório de Mecânica de Fluidos Pem/COPPE" },
        { codigo: 36030205, label: "Laboratório de Computação - Pem/COPPE" },
        { codigo: 36030300, label: "Programa de Engenharia Elétrica/COPPE" },
        { codigo: 36030301, label: "Laboratório de Controle - Pee/COPPE" },
        { codigo: 36030303, label: "Laboratório de Eletrônica - Pee/COPPE" },
        { codigo: 36030400, label: "Programa de Engenharia Metalúrgica/COPPE" },
        { codigo: 36030401, label: "Laboratório de Corrosão - Pmt/COPPE" },
        { codigo: 36030402, label: "Laboratório Fotográfico - Pmt/COPPE" },
        { codigo: 36030404, label: "Laboratório Processamento Termomecânico Eng.Microestr.COPPE" },
        { codigo: 36030407, label: "Laboratório de Propulsão Mecananica - Pmt/COPPE" },
        { codigo: 36030408, label: "Laboratório de Análise Química  Pmt/COPPE" },
        { codigo: 36030410, label: "Laboratório de Superfícies Pmt/COPPE" },
        { codigo: 36030500, label: "Programa de Engenharia Civil/COPPE" },
        { codigo: 36030502, label: "Laboratório de Traçadores - Pec/COPPE" },
        { codigo: 36030503, label: "Laboratório de Métodos Computacionais em Engenharia Pec/COPP" },
        { codigo: 36030504, label: "Laboratório de Estruturas - Pec/COPPE" },
        { codigo: 36030505, label: "Laboratório de Geotécnica - Pec/COPPE" },
        { codigo: 36030506, label: "Laboratório de Hidrologia - Pec/COPPE" },
        { codigo: 36030507, label: "Laboratório Hidráulica Computacional" },
        { codigo: 36030600, label: "Programa de Engenharia de Produção/COPPE" },
        { codigo: 36030602, label: "Laboratório de Computação - Pep/COPPE" },
        { codigo: 36030700, label: "Programa de Engenharia Oceânica/COPPE" },
        { codigo: 36030701, label: "Laboratório de Estruturas Navais - Peo/COPPE" },
        { codigo: 36030702, label: "Laboratório de Tecnologia Submarina - Peo/COPPE" },
        { codigo: 36030704, label: "Laboratório de Instrumentação Oceanográfica/COPPE" },
        { codigo: 36030705, label: "Área de Engenharia Costeira/COPPE" },
        { codigo: 36030800, label: "Programa de Engenharia Nuclear/COPPE" },
        { codigo: 36030801, label: "Laboratório de Monitoração de Processos - Pnc/COPPE" },
        { codigo: 36030803, label: "Laboratório de Instrumentação Nuclear - Pnc/COPPE" },
        { codigo: 36030900, label: "Programa de Engenharia Biomédica/COPPE" },
        { codigo: 36031000, label: "Programa de Engenharia de Sistemas/COPPE" },
        { codigo: 36031400, label: "Programa de Engenharia de Transporte/COPPE" },
        { codigo: 36031500, label: "Programa de Planejamento de Energia/COPPE" },
        { codigo: 36038900, label: "Gabinete do Diretor/COPPE" },
        { codigo: 36039000, label: "Secretaria/COPPE" },
        { codigo: 36039100, label: "Administração da Sede/COPPE" },
        { codigo: 36039130, label: "Setor de Públicação e Editoração/COPPE" },
        { codigo: 36039140, label: "Setor de Documentação - Cedoc/COPPE" },
        { codigo: 36039170, label: "Setor de Informática - Cisi/COPPE" },
        { codigo: 36039180, label: "Almoxarifado  / COPPE" },
        { codigo: 36039191, label: "Oficina de Refrigeração/COPPE" },
        { codigo: 36039192, label: "Oficina de Eletricidade/COPPE" },
        { codigo: 36039193, label: "Oficina de Obras / COPPE" },
        { codigo: 36039194, label: "Carpintaria / COPPE" },
        { codigo: 36039200, label: "Seção de Atividades Gerenciais/COPPE" },
        { codigo: 36039210, label: "Seção de Pessoal / COPPE" },
        { codigo: 36039220, label: "Seção Financeira / COPPE" },
        { codigo: 36039300, label: "Biblioteca Setorial/COPPE" },
        { codigo: 36060100, label: "Programa de Tecnologia de Polímeros/IMA" },
        { codigo: 36068900, label: "Gabinete do Diretor/IMA" },
        { codigo: 36069100, label: "Administração da Sede/IMA" },
        { codigo: 36069200, label: "Seção de Atividades Gerenciais IMA" },
        { codigo: 36069210, label: "Seção de Pessoal IMA" },
        { codigo: 36069220, label: "Seção Financeira IMA" },
        { codigo: 36069300, label: "Secretaria de Ensino de Pós-Graduação  IMA" },
        { codigo: 36070100, label: "Gabinete do Nides / CT" },
        { codigo: 36070200, label: "Setor de Recursos Humanos / NIDES / CT" },
        { codigo: 36070703, label: "RH e Gestão de Pessoas/NIDES/CT" },
        { codigo: 37000100, label: "Presidência do Fórum" },
        { codigo: 37000200, label: "Câmara de Estudos Brasileiros/FCC" },
        { codigo: 37000500, label: "Secretaria do Fórum" },
        { codigo: 37009000, label: "Seção de Pessoal/FCC" },
        { codigo: 37009100, label: "Seção de Contabilidade/FCC" },
        { codigo: 37009200, label: "Seção de Ensino/FCC" },
        { codigo: 37009300, label: "Administração da Sede/FCC" },
        { codigo: 37009500, label: "Superintendência Administrativa/FCC" },
        { codigo: 37010100, label: "Departamento de Antropologia/MN" },
        { codigo: 37010200, label: "Departamento de Geologia e Paleontologia/MN" },
        { codigo: 37010400, label: "Departamento de Botânica/MN" },
        { codigo: 37010500, label: "Departamento de Vertebrados/MN" },
        { codigo: 37010600, label: "Departamento de Invertebrados/MN" },
        { codigo: 37010700, label: "Departamento de Entomologia/MN" },
        { codigo: 37011800, label: "Núcleo de Atendimento ao Público/MN" },
        { codigo: 37017000, label: "Seção de Atividades Gerenciais MN" },
        { codigo: 37017010, label: "Seção de Pessoal MN" },
        { codigo: 37017020, label: "Seção Financeira MN" },
        { codigo: 37017030, label: "Seção de Compras/MN" },
        { codigo: 37017040, label: "Laboratório Central de Conservação e Restauração/MN" },
        { codigo: 37017050, label: "Seção de Memória e Arquivo do Museu Nacional/MN" },
        { codigo: 37017200, label: "Administração da Sede Museu Nacional" },
        { codigo: 37017300, label: "Serviço de Assistência ao Ensino/MN" },
        { codigo: 37017400, label: "Serviço de Museologia/MN" },
        { codigo: 37017500, label: "Serviço de Vigilância/MN" },
        { codigo: 37017900, label: "Gabinete do Diretor Museu Nacional" },
        { codigo: 37017901, label: "Escritório Técnico/MN" },
        { codigo: 37017902, label: "Coordenação de Comunicação e Eventos/MN" },
        { codigo: 37017903, label: "Tecnologia da Informação/MN" },
        { codigo: 37018000, label: "Secretaria do Museu Nacional" },
        { codigo: 37018100, label: "Biblioteca do Museu Nacional" },
        { codigo: 37018200, label: "Seção de Administração/Museu Nac" },
        { codigo: 37018400, label: "Horto Botânico/Museu Nac" },
        { codigo: 37018500, label: "Herbário/Museu Nacional" },
        { codigo: 37018600, label: "Garagem/Museu Nacional" },
        { codigo: 37018700, label: "Oficina/Museu Nacional" },
        { codigo: 37020200, label: "Seção de Pessoal / SIBI" },
        { codigo: 37027000, label: "Divisão de Processos Técnicos / SIBI" },
        { codigo: 37027100, label: "Divisão de Desenvolvimento da Biblioteca / SIBI" },
        { codigo: 37027200, label: "Divisão de Referência e Acervo / SIBI" },
        { codigo: 37027300, label: "Seção de Apoio Administrativo / SIBI" },
        { codigo: 37027400, label: "Biblioteca Central da Memória Acadêmica / SIBI" },
        { codigo: 37027500, label: "Divisão de Memória Institucional do SiBI" },
        { codigo: 37028900, label: "Gabinete do Diretor do Sistema de Bibliotecas" },
        { codigo: 37029000, label: "Secretaria do Sistema de Bibliotecas" },
        { codigo: 37030001, label: "Colégio Brasileiro de Altos Estudos / FCC" },
        { codigo: 37040001, label: "Casa da Ciência/FCC" },
        { codigo: 37040200, label: "Seção de Pessoal / Casa da Ciência" },
        { codigo: 37060300, label: "Direção da Universidade da Cidadania/FCC" },
        { codigo: 37070001, label: "Direção Geral/NRT" },
        { codigo: 37070100, label: "Diretoria de Administração/NRT" },
        { codigo: 37070102, label: "Seção de Pessoal / NRT" },
        { codigo: 37070200, label: "Diretoria de Produção e Conteúdo/NRT" },
        { codigo: 37070300, label: "Diretoria de Tecnologia e Operações/NRT" },
        { codigo: 37070400, label: "Diretoria de Ensino e Pesquisa/NRT" },
        { codigo: 37070500, label: "Diretoria de Extensão/NRT" },
        { codigo: 38000100, label: "Secretaria do Conselho Deliberativo" },
        { codigo: 38010100, label: "Servidores TAE - Macaé" },
        { codigo: 38010200, label: "Docentes do Campus UFRJ - Macaé" },
        { codigo: 38020001, label: "Setor de Administração - Macaé" },
        { codigo: 38020200, label: "Secretaria Geral - Macaé" },
        { codigo: 38020400, label: "Secretaria Acadêmica de Graduação  - Macaé" },
        { codigo: 38030100, label: "Departamento de Ensino de Graduação - Macaé" },
        { codigo: 38040100, label: "Departamento de Ensino de Pós-Graduação - Macaé" },
        { codigo: 38050100, label: "Servidores - Campus Macaé" },
        { codigo: 38050101, label: "NUPEM - Núcleo em Ecologia e Desenvolvimento Socioambiental" },
        { codigo: 38100001, label: "Gabinete da Direção Geral - Macaé" },
        { codigo: 38100102, label: "Setor de Recursos Humanos" },
        { codigo: 38100107, label: "Setor de Infraestrutura" },
        { codigo: 38100200, label: "Coordenação de Apoio ao Ensino de Graduação - Macaé" },
        { codigo: 38100313, label: "Coordenação do Curso de Licenciatura em Química" },
        { codigo: 39000100, label: "Direção Geral do Campus de Xerém" },
        { codigo: 39010100, label: "Servidores TAE - Xerém" },
        { codigo: 39010200, label: "Docentes - Xerém" },
        { codigo: 39020100, label: "Protocolo - Xerém" },
        { codigo: 39020200, label: "Secretaria Geral - Xerém" },
        { codigo: 39020400, label: "Secretaria Acadêmica de Graduação - Xerém" },
        { codigo: 39030100, label: "Departamento de Ensino de Graduação - Xerém" },
        { codigo: 39040100, label: "Departamento de Ensino de Pós-Graduação - Xerém" },
        { codigo: 45000100, label: "Gabinete do Diretor HU" },
        { codigo: 45000101, label: "Comissão dos Direitos dos Pacientes DG/HU" },
        { codigo: 45000102, label: "Divisão de Pesquisa DG/HU" },
        { codigo: 45000103, label: "Comitê de Ética em Pesquisa DG/HU" },
        { codigo: 45000104, label: "Ouvidoria DG/HU" },
        { codigo: 45000105, label: "Serviço de Avaliação e Epidemiologia (SEAV) DG/HU" },
        { codigo: 45000106, label: "Superintendência Geral DG/HU" },
        { codigo: 45010000, label: "Coordenação de Atividades Educacionais CAE/HU" },
        { codigo: 45010100, label: "Gabinete da Coordenação - CAE/HU" },
        { codigo: 45020100, label: "Gabinete da Coordenação de Informática e Redes CIR/HU" },
        { codigo: 45110100, label: "Gabinete do Diretor DMD/HU" },
        { codigo: 45110200, label: "Seção de Apoio e Métodos Especiais DMD/HU" },
        { codigo: 45111000, label: "Serviço de Clínica Médica DMD/HU" },
        { codigo: 45111100, label: "Serviço de Cardiologia DMD/HU" },
        { codigo: 45111300, label: "Serviço de Nefrologia DMD/HU" },
        { codigo: 45111500, label: "Serviço de Gastroenterologia DMD/HU" },
        { codigo: 45111600, label: "Serviço de Dermatologia DMD/HU" },
        { codigo: 45111700, label: "Serviço de Doenças Infecto Parasitárias DMD/HU" },
        { codigo: 45111800, label: "Serviço de Pneumologia DMD/HU" },
        { codigo: 45111900, label: "Serviço de Imunologia DMD/HU" },
        { codigo: 45112100, label: "Serviço de Nutrologia DMD/HU" },
        { codigo: 45112200, label: "Serviço de Reumatologia DMD/HU" },
        { codigo: 45112300, label: "Serviço de Neurologia DMD/HU" },
        { codigo: 45112400, label: "Serviço de Hematologia DMD/HU" },
        { codigo: 45112500, label: "Serviço de Endocrinologia DMD/HU" },
        { codigo: 45112600, label: "Serviço de Psicologia Médica DMD/HU" },
        { codigo: 45112700, label: "Serviço de Cirurgia Geral DMD/HU" },
        { codigo: 45112800, label: "Serviço de Cirurgia Vascular DMD/HU" },
        { codigo: 45112900, label: "Serviço de Cirurgia Cardíaca DMD/HU" },
        { codigo: 45113000, label: "Serviço de Proctologia DMD/HU" },
        { codigo: 45113100, label: "Serviço de Urologia DMD/HU" },
        { codigo: 45113200, label: "Serviço de Cirurgia Plástica Reparadora DMD/HU" },
        { codigo: 45113300, label: "Serviço de Neurocirurgia DMD/HU" },
        { codigo: 45113400, label: "Serviço de Traumato-Ortopedia DMD/HU" },
        { codigo: 45113500, label: "Serviço de Otorrinolaringologia DMD/HU" },
        { codigo: 45113600, label: "Serviço de Oftalmologia DMD/HU" },
        { codigo: 45113700, label: "Serviço de Cirurgia Oral DMD/HU" },
        { codigo: 45113800, label: "Serviço de Anestesiologia DMD/HU" },
        { codigo: 45113900, label: "Serviço de Ginecologia DMD/HU" },
        { codigo: 45114000, label: "Serviço de Anatomia Patológica DMD/HU" },
        { codigo: 45114200, label: "Serviço de Patologia Clínica DMD/HU" },
        { codigo: 45114300, label: "Seção de Emergência DMD/HU" },
        { codigo: 45114400, label: "Seção de Administração da Patologia Clínica DMD/HU" },
        { codigo: 45114500, label: "Serviço de Radiodiagnóstico DMD/HU" },
        { codigo: 45114600, label: "Seção de Administração da Tomografia Computadorizada DMD/HU" },
        { codigo: 45114700, label: "Serviço de Medicina Nuclear DMD/HU" },
        { codigo: 45114800, label: "Seção de Administração da Medicina Nuclear DMD/HU" },
        { codigo: 45114900, label: "Serviço de Hemoterapia DMD/HU" },
        { codigo: 45115000, label: "Serviço de Medicina Física e Reabilitação DMD/HU" },
        { codigo: 45115200, label: "Centro de Tratamento Intensivo DMD/HU" },
        { codigo: 45115300, label: "Serviço de Oncologia DMD/HU" },
        { codigo: 45115400, label: "Setor de Radioterapia DMD/HU" },
        { codigo: 45115500, label: "Setor de Hepatologia DMD/HU" },
        { codigo: 45116000, label: "Serviço de Intercorrências Clínicas e Cirúrgicas DMD/HU" },
        { codigo: 45120100, label: "Gabinete do Diretor Daa/HU" },
        { codigo: 45120200, label: "Serviço de Fisioterapia DAA/HU" },
        { codigo: 45120300, label: "Serviço de Fonoaudiologia DAA/HU" },
        { codigo: 45121000, label: "Serviço de Documentação Médica Daa/HU" },
        { codigo: 45121200, label: "Seção de Prontuários Daa/HU" },
        { codigo: 45121300, label: "Seção de Arquivo Nosológico Daa/HU" },
        { codigo: 45122000, label: "Serviço de Nutrição e Dietética Daa/HU" },
        { codigo: 45122100, label: "Seção de Nutrição Clínica Daa/HU" },
        { codigo: 45122200, label: "Seção de Nutrição Aplicada Daa/HU" },
        { codigo: 45122300, label: "Seção de Planejamento e Produção Daa/HU" },
        { codigo: 45122400, label: "Seção de Ensino Pesquisa e Estatística Daa/HU" },
        { codigo: 45123000, label: "Serviço de Farmácia Daa/HU" },
        { codigo: 45123100, label: "Seção de Administração da Farmácia Daa/HU" },
        { codigo: 45123300, label: "Seção de Guarda Distribuição de Produtos de Farmácia DAA/HU" },
        { codigo: 45123400, label: "Seção de Controle de Qualidade Daa/HU" },
        { codigo: 45123500, label: "Seção de Manipulação e Preparo de Médicamentos" },
        { codigo: 45124000, label: "Serviço Social Daa/HU" },
        { codigo: 45124100, label: "Seção de Pacientes Internos Daa/H" },
        { codigo: 45124200, label: "Seção de Pacientes Externos Daa/H" },
        { codigo: 45124300, label: "Seção de Planejamento Daa/HU" },
        { codigo: 45130100, label: "Gabinete do Diretor DSC/HU" },
        { codigo: 45130200, label: "Seção do Programa de Atendimento Domiciliar DSC/HU" },
        { codigo: 45131000, label: "Serviço de Admissão e Alta DSC/HU" },
        { codigo: 45131100, label: "Seção de Controle de Leitos DSC/HU" },
        { codigo: 45131200, label: "Seção de Informações Estatísticas DSC/HU" },
        { codigo: 45131300, label: "Seção de Controle Interno DSC/HU" },
        { codigo: 45132000, label: "Serviço de Emergência DSC/HU" },
        { codigo: 45134000, label: "Serviço de Ambulatório DSC/HU" },
        { codigo: 45140100, label: "Gabinete do Diretor DEN/HU" },
        { codigo: 45141000, label: "Serviço de Enfermagem e Saúde da Comunidade DEN/HU" },
        { codigo: 45141100, label: "Ambulatório 1 DEN/HU" },
        { codigo: 45141500, label: "Enfermaria de Acao Comunitária DEN/HU" },
        { codigo: 45141600, label: "Enfermaria do Setor de Emergência DEN/HU" },
        { codigo: 45142000, label: "Serviço de Desenvolvimento DEN/HU" },
        { codigo: 45143000, label: "Serviço de Internação Cirúrgica DEN/HU" },
        { codigo: 45143200, label: "Seção de Enfermagem 2 Cti DEN/HU" },
        { codigo: 45143300, label: "Seção de Enfermagem 3 DEN/HU" },
        { codigo: 45143400, label: "Seção de Enfermagem 4 DEN/HU" },
        { codigo: 45144000, label: "Serviço de Internação Clínica DEN/HU" },
        { codigo: 45144300, label: "Seção de Enfermagem 8 DEN/HU" },
        { codigo: 45144400, label: "Seção de Enfermagem 9 DEN/HU" },
        { codigo: 45144500, label: "Seção de Enfermagem 10 DEN/HU" },
        { codigo: 45145000, label: "Serviço de Enfermagem do Centro Cirúrgico DEN/HU" },
        { codigo: 45150100, label: "Gabinete do Diretor Drh/HU" },
        { codigo: 45151000, label: "Serviço de Administração de Pessoal Drh/HU" },
        { codigo: 45151100, label: "Seção de Registro e Controle Drh/HU" },
        { codigo: 45151200, label: "Seção de Benefícios DRH/HU" },
        { codigo: 45151300, label: "Seção de Pagamento DRH/HU" },
        { codigo: 45151400, label: "Seção de Saúde do Trabalhador DRH/HU" },
        { codigo: 45151600, label: "Seção Operacional de Pessoal DRH/HU" },
        { codigo: 45152000, label: "Serviço de Treinamento e Desenvolvimento Drh/HU" },
        { codigo: 45152200, label: "Seção de Acompanhamento Std/Drh" },
        { codigo: 45160100, label: "Gabinete do Diretor Dag/HU" },
        { codigo: 45161000, label: "Serviços Gerais Dag/HU" },
        { codigo: 45161100, label: "Seção de Arquivo e Protocolo DAG/HU" },
        { codigo: 45161200, label: "Seção de Vigilância Dag/HU" },
        { codigo: 45161300, label: "Seção de Comunicação Dag/ HU" },
        { codigo: 45161400, label: "Seção de Zeladoria Dag/HU" },
        { codigo: 45161500, label: "Seção de Rouparia Dag/HU" },
        { codigo: 45161600, label: "Seção de Transportes Dag/HU" },
        { codigo: 45162000, label: "Serviço de Material Dag/HU" },
        { codigo: 45162200, label: "Seção de Almoxarifado Dag/HU" },
        { codigo: 45162300, label: "Seção de Patrimônio Dag/HU" },
        { codigo: 45170000, label: "Divisão de Engenharia Clínica / HU" },
        { codigo: 45170100, label: "Gabinete do Diretor Deg/HU" },
        { codigo: 45171000, label: "Serviço de Planos e Projetos Deg/HU" },
        { codigo: 45171100, label: "Seção de Projetos Deg/HU" },
        { codigo: 45171200, label: "Seção de Planejamento Deg/HU" },
        { codigo: 45172000, label: "Serviço de Operação e Manutenção Deg/H" },
        { codigo: 45172100, label: "Seção de Conservação de Edifício DEG/HU" },
        { codigo: 45172200, label: "Seção de Equipamentos e Instalações Deg/HU" },
        { codigo: 45172300, label: "Seção de Eletrônica Biomédica Deg/HU" },
        { codigo: 45180100, label: "Gabinete do Diretor Dfn/HU" },
        { codigo: 45181000, label: "Serviço de Administração Financeira Dfn/HU" },
        { codigo: 45181200, label: "Seção de Tesouraria SAF/Dfn" },
        { codigo: 45181300, label: "Seção de Processamento de Contas Dfn/HU" },
        { codigo: 45182000, label: "Serviço de Planejamento e Liquidação Dfn/HU" },
        { codigo: 45182100, label: "Seção Recursos Próprios Dfn/HU" },
        { codigo: 45183200, label: "Seção de Análise SC/Dfn/HU" },
        { codigo: 53010100, label: "Gabinete da Superintendência de Tecnologia da Informação" },
        { codigo: 61070100, label: "Divisão de Ensino/PR1" },
        { codigo: 63010100, label: "Gabinete/PR3" },
        { codigo: 63040100, label: "Superintendência Geral de Planejamento e Desenvolvimento/PR3" },
        { codigo: 63050402, label: "Seção de Execução Financeira" },
        { codigo: 63060100, label: "Contadoria Geral/PR3" },
        { codigo: 63300304, label: "Seção de Reajustamento e Revisão" },
        { codigo: 64011000, label: "Protocolo" },
        { codigo: 64020100, label: "Gabinete da Pro-Reitoria de Pessoal" },
        { codigo: 64030803, label: "Seção de Concessionárias" },
        { codigo: 64031000, label: "Superintendência de Planejamento/PR4" },
        { codigo: 64032000, label: "Central de Atendimento de Pessoal/PR4" },
        { codigo: 64034000, label: "Assessoria de Demandas Judiciais/PR4" },
        { codigo: 64039900, label: "Localização - Curso Noturno" },
        { codigo: 64051000, label: "Pólos de Pessoal fora da Sede (Macaé, Praia Vermelha, Xerém)" },
        { codigo: 64060100, label: "Divisão de Pessoal" },
        { codigo: 64061000, label: "Acompanhamento de Cônjuge" },
        { codigo: 64062000, label: "Cessão" },
        { codigo: 64070100, label: "Coordenação de Políticas de Saúde do Trabalhador - CPST" },
        { codigo: 64071000, label: "Divisão de Atenção em Saúde do Trabalhador - DAST" },
        { codigo: 64072000, label: "Divisão Vigilância em Saúde Segurança do Trabalhador - DVSST" },
        { codigo: 64073000, label: "Divisão de Perícias em Saúde do Trabalhador - DPST" },
        { codigo: 64074000, label: "Divisão Administrativa - DAD" },
        { codigo: 64075000, label: "Divisão de Desenv Inovação e Marketing Institucional - DESEN" },
        { codigo: 64075002, label: "Seção de Atenção Psicossocial de Trabalhadores - SAPS" },
        { codigo: 64076000, label: "Subcoordenação Institucional" },
        { codigo: 64077000, label: "Centro de Vacinação" },
        { codigo: 64080100, label: "Divisão de Saúde do Trabalhador" },
        { codigo: 64082000, label: "Seção de Saúde e Segurança no Trabalho" },
        { codigo: 64083000, label: "Seção de Perícias Médicas" },
        { codigo: 64101000, label: "Coordenação de Gestão de Pessoal" },
        { codigo: 64101100, label: "Divisão de Benefícios e Reposição ao Erário" },
        { codigo: 64101110, label: "Seção de Benefícios" },
        { codigo: 64101120, label: "Seção de Reposição ao Erário" },
        { codigo: 64101200, label: "Divisão de Demandas Judiciais" },
        { codigo: 64101300, label: "Central de Atendimento de Pessoal/PR4" },
        { codigo: 64102000, label: "Divisão Administrativa das Comissões" },
        { codigo: 64103000, label: "Divisão de Pagamento" },
        { codigo: 64103010, label: "Seção de Pagamento de Ativos" },
        { codigo: 64103020, label: "Seção de Pagamento de Aposentados e Outros Vínculos" },
        { codigo: 64104000, label: "Divisão de Cadastro" },
        { codigo: 64105000, label: "Divisão de Publicações" },
        { codigo: 64107000, label: "Divisão de Direitos e Deveres" },
        { codigo: 64107010, label: "Seção de Amparo Legal" },
        { codigo: 64107020, label: "Seção de Procedimentos Disciplinares" },
        { codigo: 64108000, label: "Divisão de Aposentados e Pensionistas" },
        { codigo: 64108010, label: "Seção de Aposentados" },
        { codigo: 64109000, label: "Divisão de Pessoal" },
        { codigo: 64110100, label: "Subcoordenação de Legislação" },
        { codigo: 64111000, label: "Seção de Direitos e Deveres" },
        { codigo: 64112000, label: "Seção de Aposentados" },
        { codigo: 64114000, label: "Seção de Pensionistas" },
        { codigo: 64132000, label: "Seção de Benefícios" },
        { codigo: 64201000, label: "Coordenação de Política de Pessoal" },
        { codigo: 64206000, label: "Divisão de Movimentação e Alocação" },
        { codigo: 64207000, label: "Divisão de Admissão" },
        { codigo: 64208000, label: "Divisão de Avaliação de Desempenho" },
        { codigo: 64209000, label: "Divisão de Desenvolvimento" },
        { codigo: 64221000, label: "Seção de Avaliação de Desempenho" },
        { codigo: 64231000, label: "Seção de Processos de Capacitação" },
        { codigo: 64241000, label: "Subcoordenação de Seleção e Admissão" },
        { codigo: 64251000, label: "Subcoordenação de Dimensionamento e Alocação" },
        { codigo: 64251020, label: "Lotação a Determinar" },
        { codigo: 64251030, label: "Abandono de Cargo" },
        { codigo: 64255100, label: "Seção de Movimentação" },
        { codigo: 66010100, label: "Assessoria do Gabinete" },
        { codigo: 66050100, label: "Protocolo da PR6" },
        { codigo: 66100000, label: "Superintendência Geral de Governança/PR6" },
        { codigo: 66100001, label: "Gabinete da Superintendência Geral de Governança/PR6" },
        { codigo: 66100100, label: "Contador Geral" },
        { codigo: 66100200, label: "Divisão de Gestão Documental e da Informação" },
        { codigo: 66100201, label: "Seção de Gestão de Documentos/Protocolo Central" },
        { codigo: 66100203, label: "Seção de Gestão de Publicações" },
        { codigo: 66100403, label: "Seção de Processamento de Imagem" },
        { codigo: 66100600, label: "Divisão de Contabiliade" },
        { codigo: 66100601, label: "Seção de Tomada de Contas" },
        { codigo: 66100603, label: "Seção de Análise e Acompanhamento das Unidades" },
        { codigo: 66100700, label: "Divisão de Prestação de Contas" },
        { codigo: 66200100, label: "Gabinete da Sup. de Tecnologia da Informação e Comunicação" },
        { codigo: 66200200, label: "Divisão de Desenvolvimento de Sistemas" },
        { codigo: 66200300, label: "Divisão de Suporte de Sistemas e Pró-Reitorias" },
        { codigo: 66200400, label: "Divisão de Infraestrutura e Redes" },
        { codigo: 66200500, label: "Divisão de Telefonia" },
        { codigo: 66200700, label: "Coordenação de TI Campus Macaé" },
        { codigo: 66200800, label: "Coordenação de TI Campus Praia Vermelha" },
        { codigo: 66300100, label: "Gabinete da Superintendência Geral de Gestão/PR6" },
        { codigo: 66300300, label: "Divisão de Contratos" },
        { codigo: 66300302, label: "Seção de Contratos" },
        { codigo: 66300303, label: "Seção de Informações Gerenciais" },
        { codigo: 66300400, label: "Coordenação Geral de Licitações/PR6" },
        { codigo: 66300401, label: "Divisão de Licitações" },
        { codigo: 66300404, label: "Pregoeiro 2" },
        { codigo: 66300405, label: "Pregoeiro 3" },
        { codigo: 66300500, label: "Divisão de Materiais" },
        { codigo: 66300501, label: "Seção de Compras" },
        { codigo: 66300502, label: "Almoxarifado Central" },
        { codigo: 66300600, label: "Divisão Gráfica" },
        { codigo: 66300602, label: "Seção de Manutenção" },
        { codigo: 66300604, label: "Seção de Plotagem" },
        { codigo: 66300700, label: "Divisão de Serviços" },
        { codigo: 66300701, label: "Seção de Serviços" },
        { codigo: 66300702, label: "Seção de Diárias e Passagens" },
        { codigo: 66300800, label: "Divisão de Fiscalização" },
        { codigo: 66300801, label: "Seção de Controle de Execução" },
        { codigo: 66300802, label: "Seção de Faturamento" },
        { codigo: 66301000, label: "Divisão de Importação" },
        { codigo: 66301001, label: "Seção de Desembaraço" },
        { codigo: 66301100, label: "Coordenação de Logística" },
        { codigo: 66301200, label: "Coordenação Geral de Contratos e Logística" },
        { codigo: 66301201, label: "Divisão Planejamento de Contratações e Aquisições" },
        { codigo: 66301400, label: "Coordenação Geral do Serviço Integrado de Alimentação" },
        { codigo: 66400100, label: "Gabinete da Superintendência Geral de Patrimônio/PR-6" },
        { codigo: 66400201, label: "Seção de Captação de Recursos" },
        { codigo: 66400202, label: "Seção de Projetos" },
        { codigo: 66400300, label: "Divisão de Gestão Patrimonial/PR6" },
        { codigo: 66400301, label: "Seção de Bens Imóveis" },
        { codigo: 66400302, label: "Seção de Cadastro e Tombamento" },
        { codigo: 66400400, label: "Divisão de Gestão de Cessão de Uso/PR6" },
        { codigo: 66400401, label: "Seção de Cobrança" },
        { codigo: 66400402, label: "Seção de Controle e Fiscalização" },
        { codigo: 67010100, label: "Superintendência Geral de Políticas Estudantis" },
        { codigo: 67010200, label: "Divisão de Apoio ao Estudante" },
        { codigo: 67010300, label: "Divisão de Esporte, Cultura e Lazer" },
        { codigo: 67010400, label: "Divisão de Integração Pedagógica" },
        { codigo: 67010500, label: "Divisão de Residência Estudantil" },
        { codigo: 67010600, label: "Divisão de Saúde do Estudante" },
        { codigo: 67010700, label: "Seção Macaé" },
        { codigo: 67020100, label: "Assessoria Especial de Inclusão e Acessibilidade" },
        { codigo: 67020200, label: "Assessoria Especial de Assuntos Estudantis" },
        { codigo: 67020300, label: "Assessoria Especial de Planejamento" },
        { codigo: 67020500, label: "Secretaria de Gabinete" },
        { codigo: 67020600, label: "Seção de Administração/PR7" },
        { codigo: 67020700, label: "Seção de Comunicação/PR7" },
        { codigo: 88888888, label: "Pensionista" },
        { codigo: 99999999, label: "Aposentado" },
      ];
  }

  getOrgao() {
    this.orgaoList =
      [
        { codigo: 13000, label: "MINIST.DA AGRICULTURA,PECUARIA E ABAST. " },
        { codigo: 14000, label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: 15000, label: "MINISTERIO DA EDUCACAO " },
        { codigo: 16000, label: "COMANDO DO EXERCITO " },
        { codigo: 16100, label: "FUNDACAO OSORIO " },
        { codigo: 17000, label: "MINISTERIO DA ECONOMIA " },
        { codigo: 17201, label: "SUPERINTENDENCIA NAC. DE ABASTECIMENTO " },
        { codigo: 20000, label: "MINIST. DA JUSTI¸A E SEGURAN¸A PUBLICA " },
        { codigo: 20101, label: "PRESIDENCIA DA REPUBLICA " },
        { codigo: 20102, label: "VICE-PRESIDENCIA DA REPUBLICA " },
        { codigo: 20104, label: "SECRETARIA DE ASSUNTOS ESTRATEGICOS / P " },
        { codigo: 20112, label: "SECRETARIA DE PROJETOS ESPECIAIS - PR " },
        { codigo: 20113, label: "MINISTERIO DO PLANEJ. DESENV. E GESTAO " },
        { codigo: 20114, label: "AGENCIA BRASILEIRA DE INTELIGENCIA " },
        { codigo: 20115, label: "DEPARTAMENTO DE POLICIA FEDERAL " },
        { codigo: 20125, label: "CONTROLADORIA-GERAL DA UNIAO " },
        { codigo: 20224, label: "AGENCIA NACIONAL DO CINEMA " },
        { codigo: 20302, label: "NUCLEBRAS EQUIPAMENTOS PESADOS " },
        { codigo: 20304, label: "INDUSTRIAS NUCLEARES DO BRASIL " },
        { codigo: 20415, label: "EMPRESA BRASIL DE COMUNICACAO " },
        { codigo: 20605, label: "COMPANHIA DE DESENVOLV. DE BARCAREMA " },
        { codigo: 21000, label: "COMANDO DA AERONAUTICA " },
        { codigo: 21201, label: "CAIXA DE FINANCIAMENTO IMOB.AERONAUTICA " },
        { codigo: 21300, label: "AGENCIA ESPACIAL BRASILEIRA " },
        { codigo: 22000, label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: 22107, label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: 22108, label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: 22109, label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: 22200, label: "COMPANHIA NACIONAL DE ABASTECIMENTO " },
        { codigo: 22202, label: "EMPRESA BRASILEIRA DE PESQ. AGROPECUARI " },
        { codigo: 22203, label: "COMPANHIA DESENV. DO VALE SAO FRANCISCO " },
        { codigo: 22207, label: "COMPANHIA DE COLONIZACAO DO NORDESTE " },
        { codigo: 23000, label: "MINISTERIO DA PREVIDENCIA SOCIAL " },
        { codigo: 24203, label: "FUNDACAO NACIONAL DE ARTES " },
        { codigo: 24204, label: "INSTITUTO DO PATR.HIST.E ART. NACIONAL " },
        { codigo: 24205, label: "FUNDACAO BIBLIOTECA NACIONAL " },
        { codigo: 24206, label: "FUNDACAO NACIONAL DE ARTES CENICAS " },
        { codigo: 24207, label: "FUNDACAO DO CINEMA BRASILEIRO " },
        { codigo: 24209, label: "CENTRO NAC.TECNO.ELETRONICA AVANCADA S. " },
        { codigo: 25000, label: "MINISTERIO DA SAUDE " },
        { codigo: 25207, label: "SERVICO FED. DE PROCESSAMENTO DE DADOS " },
        { codigo: 25801, label: "RECEITA FEDERAL DO BRASIL " },
        { codigo: 26000, label: "MINISTERIO DO TRABALHO E EMPREGO " },
        { codigo: 26104, label: "INSTITUTO NACIONAL DE EDUCACAO DE SURDO " },
        { codigo: 26105, label: "INSTITUTO BENJAMIN CONSTANT " },
        { codigo: 26106, label: "FUNDO NACIONAL DE DESENVOLV. DA EDUCACA " },
        { codigo: 26107, label: "INST.NACIONAL DE EST.E PESQ.EDUCACIONAI " },
        { codigo: 26201, label: "COLEGIO PEDRO II " },
        { codigo: 26202, label: "CENTRO FED DE EDUC TECNOL DE ALAGOAS " },
        { codigo: 26203, label: "CENTRO FED.EDUC. TECNOLOGICA DO AMAZONA " },
        { codigo: 26204, label: "CENTRO FED. DE EDUC. TECNOL. DA BAHIA " },
        { codigo: 26205, label: "CENTRO FED.DE EDUC.TECNOL. DE CAMPOS " },
        { codigo: 26206, label: "CENTRO FED.DE EDUC.TECNOL.DO CEARA " },
        { codigo: 26207, label: "CENTRO FED.DE EDUC.TECNOL.ESPIRITO SANT " },
        { codigo: 26208, label: "CENTRO FED.DE EDUC.TECNOL. DE GOIAS " },
        { codigo: 26209, label: "CENTRO FED. DE EDUC. TECNOL. DO MARANHA " },
        { codigo: 26210, label: "CENTRO FED DE EDUC TEC DE MATO GROSSO " },
        { codigo: 26211, label: "CENTRO FED.DE EDUC.TECNOL. DE OURO PRET " },
        { codigo: 26212, label: "CENTRO FED.DE EDUC.TECNOL.DO PARA " },
        { codigo: 26213, label: "CENTRO FED.DE EDUC.TECNOL.DA PARAIBA " },
        { codigo: 26214, label: "CENTRO FED.DE EDUC.TECNOL.DE PELOTAS " },
        { codigo: 26215, label: "CENTRO FED.DE EDUC.TECNOL. DE PERNAMBUC " },
        { codigo: 26216, label: "CENTRO FED.DE EDUC.TECNOL. DO PIAUI " },
        { codigo: 26217, label: "CEFET DE QUIMICA DE NILOPOLIS-RJ " },
        { codigo: 26218, label: "CENTRO FED.EDUC.TECNOL.DO R. G. DO NORT " },
        { codigo: 26219, label: "CENTRO FED EDUC TEC DE SANTA CATARINA " },
        { codigo: 26220, label: "CENTRO FED.DE EDUC.TECNOL.DE SAO PAULO " },
        { codigo: 26221, label: "CENTRO FEDERAL DE EDUC TEC DE SERGIPE " },
        { codigo: 26222, label: "CENTRO FED.DE EDUC.TECNOL. DE RORAIMA " },
        { codigo: 26223, label: "ESCOLA TECNICA FEDERAL DE PALMAS " },
        { codigo: 26227, label: "ESCOLA TECNICA FEDERAL DE RONDONIA " },
        { codigo: 26230, label: "FUND.UNIV.FED.DO VALE DO SAO FRANCISCO " },
        { codigo: 26231, label: "UNIVERSIDADE FEDERAL DE ALAGOAS " },
        { codigo: 26232, label: "UNIVERSIDADE FEDERAL DA BAHIA " },
        { codigo: 26233, label: "UNIVERSIDADE FEDERAL DO CEARA " },
        { codigo: 26234, label: "UNIVERSIDADE FEDERAL DO ESPIRITO SANTO " },
        { codigo: 26235, label: "UNIVERSIDADE FEDERAL DE GOIAS " },
        { codigo: 26236, label: "UNIVERSIDADE FEDERAL FLUMINENSE " },
        { codigo: 26237, label: "UNIVERSIDADE FEDERAL DE JUIZ DE FORA " },
        { codigo: 26238, label: "UNIVERSIDADE FEDERAL DE MINAS GERAIS " },
        { codigo: 26239, label: "UNIVERSIDADE FEDERAL DO PARA " },
        { codigo: 26240, label: "UNIVERSIDADE FEDERAL DA PARAIBA " },
        { codigo: 26241, label: "UNIVERSIDADE FEDERAL DO PARANA " },
        { codigo: 26242, label: "UNIVERSIDADE FEDERAL DE PERNAMBUCO " },
        { codigo: 26243, label: "UNIVERSIDADE FED. DO RIO GRANDE DO NORT " },
        { codigo: 26244, label: "UNIVERSIDADE FED. DO RIO GRANDE DO SUL " },
        { codigo: 26245, label: "UNIVERSIDADE FEDERAL DO RIO DE JANEIRO " },
        { codigo: 26246, label: "UNIVERSIDADE FEDERAL DE SANTA CATARINA " },
        { codigo: 26247, label: "UNIVERSIDADE FEDERAL DE SANTA MARIA " },
        { codigo: 26248, label: "UNIVERSIDADE FEDERAL RURAL DE PERNAMBUC " },
        { codigo: 26249, label: "UNIV. FEDERAL RURAL DO RIO DE JANEIRO " },
        { codigo: 26250, label: "UNIVERSIDADE FEDERAL DE RORAIMA " },
        { codigo: 26251, label: "FUNDACAO UNIVERSIDADE FED. DO TOCANTINS " },
        { codigo: 26252, label: "UNIVERSIDADE FEDERAL DE CAMPINA GRANDE " },
        { codigo: 26253, label: "UNIVERSIDADE FEDERAL RURAL DA AMAZONIA " },
        { codigo: 26254, label: "UNIVERSIDADE FED.DO TRIANGULO MINEIRO " },
        { codigo: 26255, label: "UNI.FED.VALES DO JEQUITINHONHA E MUCURI " },
        { codigo: 26256, label: "CENTRO FED.EDUC.TECNOL.CELSO S. FONSECA " },
        { codigo: 26257, label: "CENTRO FED.DE EDUC.TECNOL.MINAS GERAIS " },
        { codigo: 26258, label: "UNIVERS. TECNOLOGICA FEDERAL DO PARANA " },
        { codigo: 26259, label: "CENTRO DE EDUC. TECNOLOGICA DA BAHIA " },
        { codigo: 26260, label: "UNIVERSIDADE FEDERAL DE ALFENAS " },
        { codigo: 26261, label: "UNIVERSIDADE FEDERAL DE ITAJUBA " },
        { codigo: 26262, label: "UNIVERSIDADE FEDERAL DE SAO PAULO " },
        { codigo: 26263, label: "UNIVERSIDADE FEDERAL DE LAVRAS " },
        { codigo: 26264, label: "UNIVERSIDADE FED. RURAL DO SEMI-ARIDO " },
        { codigo: 26266, label: "FUNDACAO UNIVERSIDADE FEDERAL DO PAMPA " },
        { codigo: 26267, label: "UNIV.FED. DA INTEGRACAO LATINO-AMERICAN " },
        { codigo: 26268, label: "FUND. UNIVERSIDADE FEDERAL DE RONDONIA " },
        { codigo: 26269, label: "UNIVERSIDADE DO RIO DE JANEIRO " },
        { codigo: 26270, label: "FUNDACAO UNIVERSIDADE DO AMAZONAS " },
        { codigo: 26271, label: "FUNDACAO UNIVERSIDADE DE BRASILIA " },
        { codigo: 26272, label: "FUNDACAO UNIVERSIDADE DO MARANHAO " },
        { codigo: 26273, label: "UNIVERSIDADE FEDERAL DO RIO GRANDE " },
        { codigo: 26274, label: "FUNDACAO UNIV. FEDERAL DE UBERLANDIA " },
        { codigo: 26275, label: "UNIVERSIDADE FEDERAL DO ACRE " },
        { codigo: 26276, label: "UNIVERSIDADE FEDERAL DE MATO GROSSO " },
        { codigo: 26277, label: "FUNDACAO UNIV. FEDERAL DE OURO PRETO " },
        { codigo: 26278, label: "FUNDACAO UNIVERSIDADE FEDERAL DE PELOTA " },
        { codigo: 26279, label: "UNIVERSIDADE FEDERAL DO PIAUI " },
        { codigo: 26280, label: "UNIVERSIDADE FEDERAL DE SAO CARLOS " },
        { codigo: 26281, label: "FUNDACAO UNIVERSIDADE FEDERAL DE SERGIP " },
        { codigo: 26282, label: "UNIVERSIDADE FEDERAL DE VICOSA " },
        { codigo: 26283, label: "UNIV. FEDERAL DE MATO GROSSO DO SUL " },
        { codigo: 26284, label: "FUND.UNIV.FED.CIENC.SAUDE D PORTO ALEGR " },
        { codigo: 26285, label: "FUND. UNIVERSIDADE DE SAO JOAO DEL REI " },
        { codigo: 26286, label: "FUNDACAO UNVERSIDADE FEDERAL DO AMAPA " },
        { codigo: 26287, label: "ESCOLA AGROTECNICA FEDERAL DE MARABA " },
        { codigo: 26292, label: "FUNDACAO JOAQUIM NABUCO " },
        { codigo: 26293, label: "FUNDACAO ROQUETE PINTO " },
        { codigo: 26295, label: "INSTITUTO NACIONAL DE DESENV.DO DESPORT " },
        { codigo: 26296, label: "FUNDACAO EDUCAR " },
        { codigo: 26297, label: "FUNDACAO DE ASSISTENCIA AO ESTUDANTE " },
        { codigo: 26298, label: "FUND COORD APERF PESSOAL NIVEL SUPERIOR " },
        { codigo: 26300, label: "ESCOLA AGROTECNICA FEDERAL DE SATUBA " },
        { codigo: 26301, label: "ESCOLA AGROTECNICA FEDERAL DE MANAUS " },
        { codigo: 26302, label: "ESCOLA AGROTECNICA FEDERAL DE CATU " },
        { codigo: 26303, label: "ESCOLA AGROTECNICA FEDERAL DE CRATO " },
        { codigo: 26304, label: "ESCOLA AGROTECNICA FEDERAL DE IGUATU " },
        { codigo: 26305, label: "ESCOLA AGROTECNICA FEDERAL DE ALEGRE " },
        { codigo: 26306, label: "CENTRO FEDERAL DE EDUC TECNOL RIO VERDE " },
        { codigo: 26307, label: "ESCOLA AGROTECNICA FEDERAL DE SAO LUIS " },
        { codigo: 26308, label: "CENTRO FED. DE EDUC. TECNOL. DE BAMBUI " },
        { codigo: 26309, label: "ESCOLA AGROTECNICA FEDERAL DE BARBACENA " },
        { codigo: 26310, label: "CENTRO FED. DE EDUC.TECNOL. DE JANUARIA " },
        { codigo: 26311, label: "ESCOLA AGROTECNICA FEDERAL DE MUZAMBINH " },
        { codigo: 26312, label: "CENTRO FED. DE  EDUC.TECNOL.DE RIO POMB " },
        { codigo: 26313, label: "CENTRO FEDERAL EDUC.TECNOL.DE UBERABA " },
        { codigo: 26314, label: "ESCOLA AGROTECNICA FEDERAL DE UBERLANDI " },
        { codigo: 26315, label: "ESCOLA AGROTECNICA FEDERAL DE CASTANHAL " },
        { codigo: 26316, label: "ESCOLA AGROTECNICA FEDERAL DE SOUSA " },
        { codigo: 26317, label: "ESCOLA AGROTECNICA FEDERAL DE BARREIROS " },
        { codigo: 26318, label: "ESCOLA AGROTECNICA FED. DE BELO JARDIM " },
        { codigo: 26319, label: "ESCOLA AGROT.FED. DE VIT. DE S. ANTAO " },
        { codigo: 26320, label: "ESCOLA AGROTECNICA FED. DE SAO CRISTOVA " },
        { codigo: 26321, label: "CENTRO FED EDUC TEC.DE BENTO GONCALVES " },
        { codigo: 26322, label: "ESCOLA AGROTECNICA FEDERAL DE CONCORDIA " },
        { codigo: 26323, label: "ESCOLA AGROTECNICA FEDERAL DE SERTAO " },
        { codigo: 26324, label: "ESCOLA AGROTECNICA FEDERAL DE COLATINA " },
        { codigo: 26325, label: "CENTRO FEDERAL DE EDUC.TECNOL.DE URUTAI " },
        { codigo: 26326, label: "CENTRO FEDERAL DE EDUC.TECNOL. DE CUIAB " },
        { codigo: 26327, label: "ESCOLA AGROTECNICA FED. DE INCONFIDENTE " },
        { codigo: 26328, label: "ESCOLA AGROTECNICA FEDERAL DE MACHADO " },
        { codigo: 26329, label: "ESCOLA AGROTECNICA FEDERAL DE SALINAS " },
        { codigo: 26330, label: "ESCOLA AGROT. FED. DE S.J. EVANGELISTA " },
        { codigo: 26331, label: "ESCOLA AGROTECNICA FED. DE ARAGUATINS " },
        { codigo: 26332, label: "ESCOLA AGROTECNICA FEDERAL DE CACERES " },
        { codigo: 26333, label: "ESCOLA AGROTECNICA FEDERAL DE ALEGRETE " },
        { codigo: 26335, label: "ESCOLA AGROTECNICA FED. DE STA. TERESA " },
        { codigo: 26336, label: "CENTRO FED. DE ED. TEC. DE PETROLINA " },
        { codigo: 26337, label: "ESCOLA AGROTECNICA FEDERAL DE CERES " },
        { codigo: 26338, label: "CENTRO FED. EDUC.TEC. S VICENTE DO SUL " },
        { codigo: 26339, label: "ESCOLA AGROT.FED.COLORADO DO OESTE " },
        { codigo: 26340, label: "ESCOLA AGROT.FED.S.GABRIEL DA CACHOEIRA " },
        { codigo: 26341, label: "ESCOLA AGROTECNICA FEDERAL DE SOMBRIO " },
        { codigo: 26342, label: "ESCOLA AGROTECNICA FEDERAL DE RIO DO SU " },
        { codigo: 26343, label: "ESCOLA AGROTEC.FED.ANTONIO JOSE TEIXEIR " },
        { codigo: 26344, label: "ESCOLA AGROTEC. FEDERAL DE SANTA INES/B " },
        { codigo: 26345, label: "ESCOLA AGROTECNICA FEDERAL DE CODO/MA " },
        { codigo: 26346, label: "ESCOLA AGROT.FEDERAL SENHOR DO BONFIM/B " },
        { codigo: 26350, label: "FUND. UNIV FEDERAL DA GRANDE DOURADOS " },
        { codigo: 26351, label: "UNIV. FEDERAL DO RECONCAVO DA BAHIA " },
        { codigo: 26352, label: "FUNDACAO UNIVERSIDADE FEDERAL DO ABC " },
        { codigo: 26353, label: "ESCOLA TECNICA FEDERAL DO ACRE " },
        { codigo: 26354, label: "ESCOLA TECNICA FEDERAL DO AMAPA " },
        { codigo: 26356, label: "INST. FED. ED. CIENCIA E TEC.DE BRASILI " },
        { codigo: 26357, label: "ESCOLA TECNICA FEDERAL DE CANOAS " },
        { codigo: 26401, label: "INSTITUTO FEDERAL DO ACRE " },
        { codigo: 26402, label: "INSTITUTO FEDERAL DE ALAGOAS " },
        { codigo: 26403, label: "INSTITUTO FEDERAL DO AMAZONAS " },
        { codigo: 26404, label: "INSTITUTO FEDERAL BAIANO " },
        { codigo: 26405, label: "INSTITUTO FEDERAL DO CEARA " },
        { codigo: 26406, label: "INSTITUTO FEDERAL DO ESPIRITO SANTO " },
        { codigo: 26407, label: "INSTITUTO FEDERAL GOIANO " },
        { codigo: 26408, label: "INSTITUTO FEDERAL DO MARANHAO " },
        { codigo: 26409, label: "INSTITUTO FEDERAL DE MINAS GERAIS " },
        { codigo: 26410, label: "INSTITUTO FED. DO NORTE DE MINAS GERAIS " },
        { codigo: 26411, label: "INSTITUTO FED.DO SUDESTE DE MINAS GERAI " },
        { codigo: 26412, label: "INSTITUTO FEDERAL DO SUL DE MINAS GERAI " },
        { codigo: 26413, label: "INSTITUTO FEDERAL DO TRIANGULO MINEIRO " },
        { codigo: 26414, label: "INSTITUTO FEDERAL DE MATO GROSSO " },
        { codigo: 26415, label: "INSTITUTO FEDERAL DE MATO GROSSO DO SUL " },
        { codigo: 26416, label: "INSTITUTO FEDERAL DO PARA " },
        { codigo: 26417, label: "INSTITUTO FEDERAL DA PARAIBA " },
        { codigo: 26418, label: "INSTITUTO FEDERAL DE PERNAMBUCO " },
        { codigo: 26419, label: "INSTITUTO FEDERAL DO RIO GRANDE DO SUL " },
        { codigo: 26420, label: "INSTITUTO FEDERAL FARROUPILHA " },
        { codigo: 26421, label: "INSTITUTO FEDERAL DE RONDONIA " },
        { codigo: 26422, label: "INSTITUTO FEDERAL CATARINENSE " },
        { codigo: 26423, label: "INSTITUTO FEDERAL DE SERGIPE " },
        { codigo: 26424, label: "INSTITUTO FEDERAL DO TOCANTINS " },
        { codigo: 26426, label: "INSTITUTO FEDERAL DO AMAPA " },
        { codigo: 26427, label: "INSTITUTO FEDERAL DA BAHIA " },
        { codigo: 26428, label: "INSTITUTO FEDERAL DE BRASILIA " },
        { codigo: 26429, label: "INSTITUTO FEDERAL DE GOIAS " },
        { codigo: 26430, label: "INSTITUTO FEDERAL DO SERTAO PERNAMBUCAN " },
        { codigo: 26431, label: "INSTITUTO FEDERAL DO PIAUI " },
        { codigo: 26432, label: "INSTITUTO FEDERAL DO PARANA " },
        { codigo: 26433, label: "INSTITUTO FEDERAL DO RIO DE JANEIRO " },
        { codigo: 26434, label: "INSTITUTO FEDERAL FLUMINENSE " },
        { codigo: 26435, label: "INSTITUTO FEDERAL DO RIO GRANDE DO NORT " },
        { codigo: 26436, label: "INSTITUTO FEDERAL SUL RIO-GRANDENSE " },
        { codigo: 26437, label: "INSTITUTO FEDERAL DE RORAIMA " },
        { codigo: 26438, label: "INSTITUTO FEDERAL DE SANTA CATARINA " },
        { codigo: 26439, label: "INSTITUTO FEDERAL DE SAO PAULO " },
        { codigo: 26440, label: "UNIVERSIDADE FEDERAL DA FRONTEIRA SUL " },
        { codigo: 26441, label: "UNIVERSIDADE FEDERAL DO OESTE DO PARA " },
        { codigo: 26442, label: "UN. INT.INTERN. LUSOFONIA AFROBRASILEIR " },
        { codigo: 26443, label: "EMPRESA BRAS. DE SERVICOS HOSPITALARES " },
        { codigo: 26447, label: "UNIVERSIDADE FEDERAL DO OESTE DA BAHIA " },
        { codigo: 26448, label: "UNIVERSIDADE FED. SUL SUDESTE DO PARA " },
        { codigo: 26449, label: "UNIVERSIDADE FEDERAL DO CARIRI " },
        { codigo: 26450, label: "UNIVERSIDADE FEDERAL DO SUL DA BAHIA " },
        { codigo: 27000, label: "MINISTERIO DA INFRA-ESTRUTURA " },
        { codigo: 28000, label: "MINISTERIO IND. COM. EXTERIOR E SERVI§O " },
        { codigo: 29000, label: "MINISTERIO DO ESPORTE " },
        { codigo: 29202, label: "SUP.DE DESENVOLVIMENTO DO CENTRO OESTE " },
        { codigo: 29203, label: "EMPRESA BRAS. DE PLANEJ. DE TRANSPORTES " },
        { codigo: 29205, label: "EMPRESA DE TRENS URBANOS DE PORTO ALEGR " },
        { codigo: 29214, label: "COMPANHIA BRASILEIRA DE TRENS URBANOS " },
        { codigo: 30102, label: "IMPRENSA NACIONAL " },
        { codigo: 30202, label: "FUNDACAO NACIONAL DO INDIO " },
        { codigo: 30203, label: "INST.NAC.METROLOGIA,NORM.E QUAL.INDL. " },
        { codigo: 30204, label: "INSTITUTO NAC. DA PROPRIEDADE INDUSTRIA " },
        { codigo: 30802, label: "DEPTO. DE POLICIA RODOVIARIA FEDERAL " },
        { codigo: 31000, label: "MINIST. ECONOMIA, FAZENDA E PLANEJAMENT " },
        { codigo: 31203, label: "INSTITUTO BRASILEIRO DO CAFE " },
        { codigo: 32000, label: "MINISTERIO DE MINAS E ENERGIA " },
        { codigo: 32100, label: "DEPARTAMENTO NAC. DE PRODUCAO MINERAL " },
        { codigo: 32200, label: "AGENCIA NACIONAL DE ENERGIA ELETRICA " },
        { codigo: 32300, label: "AGENCIA NAC PETROLEO GAS NAT BIOCOMBUST " },
        { codigo: 32314, label: "EMPRESA DE PESQUISA ENERGETICA " },
        { codigo: 32396, label: "AGENCIA NACIONAL DE MINERACAO " },
        { codigo: 33206, label: "SUPERINT.NAC.DE PREVIDENCIA COMPLEMENTA " },
        { codigo: 34000, label: "SECRETARIA DA CULTURA / PR " },
        { codigo: 35000, label: "MINISTERIO DAS RELACOES EXTERIORES " },
        { codigo: 35201, label: "FUNDACAO ALEXANDRE DE GUSMAO " },
        { codigo: 36102, label: "FUNDACAO NACIONAL DE SAUDE " },
        { codigo: 36103, label: "CENTRAL DE MEDICAMENTOS " },
        { codigo: 36201, label: "FUNDACAO OSWALDO CRUZ " },
        { codigo: 36203, label: "INST. NACIONAL DE ALIMENTACAO E NUTRICA " },
        { codigo: 36204, label: "FUNDACAO DAS PIONEIRAS SOCIAIS " },
        { codigo: 36205, label: "FUNDACAO NACIONAL DE SAUDE " },
        { codigo: 36206, label: "EX-INST. NAC.DE ASS. MED. DA PREV.SOCIA " },
        { codigo: 36207, label: "AGENCIA NACIONAL DE VIGILANCIA SANITARI " },
        { codigo: 36208, label: "AGENCIA NACIONAL DE SAUDE SUPLEMENTAR " },
        { codigo: 36209, label: "HOSPITAL FEMINA " },
        { codigo: 36210, label: "HOSPITAL NOSSA SENHORA DA CONCEICAO " },
        { codigo: 36211, label: "HOSPITAL CRISTO REDENTOR " },
        { codigo: 37000, label: "DEFENSORIA PUBLICA DA UNIAO " },
        { codigo: 38000, label: "CONSELHO ADMINIST.DE DEFESA ECONOMICA " },
        { codigo: 39250, label: "AGENCIA NAC. DE TRANSPORTES TERRESTRES " },
        { codigo: 39251, label: "AGENCIA NAC. DE TRANSPORTES AQUAVIARIOS " },
        { codigo: 39252, label: "DEPARTAMENTO NAC.DE INFRAEST. DE TRANSP " },
        { codigo: 39253, label: "EMPRESA DE PLANEJAMENTO E LOGISTICA S.A " },
        { codigo: 40000, label: "CENTRAL DE ATENDIMENTO DRH/SAF/PR " },
        { codigo: 40103, label: "MINIST.DA ADM.FEDERAL E REF. DO ESTADO " },
        { codigo: 40105, label: "MINISTERIO DA DEFESA " },
        { codigo: 40106, label: "ADVOCACIA-GERAL DA UNIAO " },
        { codigo: 40107, label: "MINISTERIO DA CULTURA " },
        { codigo: 40108, label: "MINIST»RIO CI¼NCIA TEC.INOV.COMUNICA¸ùE " },
        { codigo: 40109, label: "EX-MINISTERIO DA INTEGRACAO REGIONAL " },
        { codigo: 40110, label: "SECRETARIA DE DESPORTOS / PR " },
        { codigo: 40111, label: "MINISTERIO DO MEIO AMBIENTE " },
        { codigo: 40112, label: "MINISTERIO DO DESENVOLVIMENTO REGIONAL " },
        { codigo: 40202, label: "FUNDACAO ESCOLA NACIONAL DE ADM. PUBLIC " },
        { codigo: 40301, label: "COMISSAO NACIONAL DE ENERGIA NUCLEAR " },
        { codigo: 40403, label: "FUNDACAO CASA DE RUI BARBOSA " },
        { codigo: 40408, label: "FUNDACAO CULTURAL PALMARES " },
        { codigo: 40501, label: "CONSELHO NAC.DE DESEN.CIEN.E TECNOLOGIC " },
        { codigo: 40503, label: "FUNDACAO CENTRO TECNOL. PARA INFORMATIC " },
        { codigo: 40601, label: "SUPERINT. DO DESENVOLVIMENTO DO NORDEST " },
        { codigo: 40602, label: "SUPERINTENDENCIA DO DESENV. DA AMAZONIA " },
        { codigo: 40603, label: "SUPERINTENDENCIA ZONA FRANCA DE MANAUS " },
        { codigo: 40604, label: "INSTITUTO BRASILEIRO DE TURISMO " },
        { codigo: 40701, label: "INST. BR. MEIO AMB. REC. NAT. RENOVAVEI " },
        { codigo: 40801, label: "GOVERNO DO EX-TERRITORIO DO AMAPA " },
        { codigo: 40802, label: "GOVERNO DO EX-TERRITORIO DO ACRE " },
        { codigo: 40803, label: "GOVERNO DO EX-TERRITORIO DE RONDONIA " },
        { codigo: 40804, label: "GOVERNO DO EX-TERRITORIO DE RORAIMA " },
        { codigo: 40805, label: "ANTIGO EST.GUANABARA E DISTRITO FEDERAL " },
        { codigo: 40806, label: "DEP.DE CENTRAL.SERV.DE INATIVOS E PENS. " },
        { codigo: 41000, label: "MINISTERIO DAS COMUNICACOES " },
        { codigo: 41200, label: "EMPRESA BRASILEIRA DE COMUNICACAO S.A. " },
        { codigo: 41231, label: "AGENCIA NACIONAL DE TELECOMUNICACOES " },
        { codigo: 42000, label: "MINISTERIO DO DESENVOLVIMENTO AGRARIO " },
        { codigo: 42102, label: "COMISSAO EXEC. PLANO LAVOURA CACAUEIRA " },
        { codigo: 42201, label: "INSTITUTO NAC. DE COLONIZ E REF AGRARIA " },
        { codigo: 42204, label: "DEPTO. NACIONAL DE OBRAS CONTRA AS SECA " },
        { codigo: 42207, label: "INSTITUTO BRASILEIRO DE MUSEUS " },
        { codigo: 43000, label: "EX-MINISTERIO DO BEM-ESTAR SOCIAL " },
        { codigo: 43201, label: "EX-FUND.CENTRO BRAS. P.INFANC./ADOLESC " },
        { codigo: 43202, label: "EX-FUNDACAO LEGIAO BRAS. DE ASSISTENCIA " },
        { codigo: 44205, label: "AGENCIA NACIONAL DE AGUAS " },
        { codigo: 44206, label: "INSTITUTO DE PESQ. JARDIM BOTANICO DO R " },
        { codigo: 44207, label: "INSTITUTO CHICO MENDES CONSERV.BIODIVER " },
        { codigo: 45203, label: "COMISSAO DE VALORES MOBILIARIOS " },
        { codigo: 45205, label: "FUND. INST. BRASIL. GEOG. E ESTATISTICA " },
        { codigo: 45206, label: "INSTITUTO DE PESQUISA ECONOMICA APLICAD " },
        { codigo: 45208, label: "SUPERINTENDENCIA DE SEGUROS PRIVADOS " },
        { codigo: 46000, label: "MICT " },
        { codigo: 49000, label: "MINISTERIO DA INFRAESTRUTURA " },
        { codigo: 49201, label: "DEPARTAMENTO NAC. DE ESTRADAS DE RODAGE " },
        { codigo: 49300, label: "VALEC ENG.CONSTRUCOES E FERROVIAS S/A " },
        { codigo: 51000, label: "AUTORIDADE.DE GOVER.DO LEGADO OLIMPICO " },
        { codigo: 52201, label: "AGENCIA NACIONAL DE AVIACAO CIVIL " },
        { codigo: 52233, label: "AMAZONIA AZUL TECNOLOGIAS DE DEFESA SA " },
        { codigo: 53202, label: "SUPERINTENDENCIA DO DESENV. DA AMAZONIA " },
        { codigo: 53203, label: "SUPERINTENDENCIA DO DESENV. DO NORDESTE " },
        { codigo: 53205, label: "AGENCIA DE DESENVOLVIMENTO DA AMAZONIA " },
        { codigo: 53206, label: "AGENCIA DE DESENVOLVIMENTO DO NORDESTE " },
        { codigo: 53297, label: "SUP.DE DESENVOLVIMENTO DO CENTRO OESTE " },
        { codigo: 54000, label: "MINISTERIO DO TURISMO " },
        { codigo: 55000, label: "MINISTERIO DA CIDADANIA " },
        { codigo: 56000, label: "MINISTERIO DAS CIDADES " },
        { codigo: 57201, label: "FUND.JORGE DUPRAT FIG. SEG. MED.TRABALH " },
        { codigo: 57202, label: "INSTITUTO NACIONAL DE SEGURO SOCIAL " },
        { codigo: 57203, label: "EMPR.DE PROCESS.DE DADOS DA PREV.SOCIAL " },
        { codigo: 58000, label: "MINISTERIO DE PESCA E AQUICULTURA " },
        { codigo: 59000, label: "CONTROLADORIA-GERAL DA UNIAO " },
        { codigo: 70000, label: "COMANDO DA MARINHA " },
        { codigo: 70101, label: "MINISTERIO DA MARINHA II " },
        { codigo: 70102, label: "TRIBUNAL MARITIMO " },
        { codigo: 77000, label: "FUND PREV COMPL SERV PUBL FED EXECUTIVO " },
        { codigo: 80101, label: "INST.DE PREV.SOC. DO SERVIDOR PUBLICO " },
        { codigo: 80202, label: "SUPERINTENDENCIA DO DES. DA REGIAO SUL " },
        { codigo: 80203, label: "DEPART. NAC. DE O. DE SANEAMENTO ( EXT. " },
        { codigo: 80204, label: "INSTITUTO DO ACUCAR E DO ALCOOL " },
        { codigo: 81000, label: "MIN. DA MULHER, FAMILIA E DIR. HUMANOS " },
        { codigo: 90150, label: "MINISTERIO PUBLICO DA UNIAO " },
        { codigo: 91214, label: "AUTORIDADE PUBLICA OLIMPICA " },
        { codigo: 99007, label: "COMPANHIA DE NAVEGACAO DO SAO FRANCISCO " },
        { codigo: 99009, label: "EMPRESA DE NAVEGACAO DA AMAZONIA " },
        { codigo: 99010, label: "COMPANHIA DE PESQUISA DE REC. MINERAIS " },
        { codigo: 99013, label: "HOSPITAL DE CLINICAS DE PORTO ALEGRE " },
        { codigo: 99016, label: "SENADO FEDERAL " },
        { codigo: 99072, label: "GOVERNO DO DISTRITO FEDERAL " },
        { codigo: 99074, label: "GOVERNO DO DISTRITO FEDERAL " },
        { codigo: 99901, label: "CONSELHO DE JUSTICA FEDERAL " },
        { codigo: 99991, label: "ESTADOS / MUNICIPIOS / EMPRESAS " }
      ]

  }
  buscarBancos(){
    this._http
    .get(config.urlAPI + "listar/bancos", {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      this.bancos = res;
    }).catch(err => {
      console.log(err)

    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/cadastro/cadastro.ts